(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f9e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f9e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h8xzT", function(module, exports) {

$parcel$export(module.exports, "PATHNAMES", () => $daf45864789f625f$export$9ad14074d6a2b6f8);
const $daf45864789f625f$export$9ad14074d6a2b6f8 = {
    socialProviders: "/ims/social/v2/providers",
    socialCompleteAccount: "/signin/v2/accounts/social/create",
    socialNativeHeadless: "/ims/social/v3/native",
    validateOrigin: "/ims/clients/validate/v1",
    check: "/ims/check/v6/token",
    IJT: "/ims/jump/implicit",
    queryState: "/signin/v1/queryState"
};

});

parcelRegister("lJO9z", function(module, exports) {

$parcel$export(module.exports, "buildURL", () => $be0f210bba242519$export$f4c938b84f3b29d9);
$parcel$export(module.exports, "getClientId", () => $be0f210bba242519$export$8a452ee356909bac);
$parcel$export(module.exports, "getLocale", () => $be0f210bba242519$export$180605366c04f0cd);
$parcel$export(module.exports, "setSentry", () => $be0f210bba242519$export$3497527809e7dcd3);
$parcel$export(module.exports, "wait", () => $be0f210bba242519$export$5c069c93d2b7493f);
$parcel$export(module.exports, "getRelay", () => $be0f210bba242519$export$1e0f363384bbe072);
$parcel$export(module.exports, "getPostMessagePort", () => $be0f210bba242519$export$4ef9c1cc8696d2de);
$parcel$export(module.exports, "logError", () => $be0f210bba242519$export$58da9968c3170cb1);
$parcel$export(module.exports, "logCritical", () => $be0f210bba242519$export$2584992308717284);
$parcel$export(module.exports, "logInfo", () => $be0f210bba242519$export$89c0607256d35f0a);
$parcel$export(module.exports, "responseToInfo", () => $be0f210bba242519$export$2e7125f6dc82fcb4);
$parcel$export(module.exports, "broadcastLastResortError", () => $be0f210bba242519$export$d4c835785770a710);
$parcel$export(module.exports, "capitalizeStr", () => $be0f210bba242519$export$fdf252fdc56190c3);

var $35vl8 = parcelRequire("35vl8");
parcelRequire("8Tavf");
var $4S9FR = parcelRequire("4S9FR");

var $jirw5 = parcelRequire("jirw5");

var $3BQJL = parcelRequire("3BQJL");

var $gigCS = parcelRequire("gigCS");
const { getApiUrl: $be0f210bba242519$var$getApiUrl } = (0, $jirw5.urls).create((0, $jirw5.envs).getAppEnv);
function $be0f210bba242519$export$f4c938b84f3b29d9(pathname) {
    const apiUrl = $be0f210bba242519$var$getApiUrl();
    if (apiUrl) return new URL(pathname, apiUrl);
    throw new Error("Unexpected void value for API URL");
}
function $be0f210bba242519$export$8a452ee356909bac() {
    const searchParams = new URLSearchParams(window.location.search);
    var _searchParams_get;
    return (_searchParams_get = searchParams.get("client_id")) !== null && _searchParams_get !== void 0 ? _searchParams_get : "";
}
function $be0f210bba242519$export$180605366c04f0cd() {
    const searchParams = new URLSearchParams(window.location.search);
    var _searchParams_get;
    return (0, $4S9FR.sanitizeLocale)((_searchParams_get = searchParams.get("locale")) !== null && _searchParams_get !== void 0 ? _searchParams_get : "");
}
function $be0f210bba242519$export$3497527809e7dcd3(slice) {
    const { __sentry__: __sentry__ } = window;
    window.__sentry__ = (0, $35vl8._)({}, __sentry__ || {}, slice);
}
function $be0f210bba242519$export$5c069c93d2b7493f(time) {
    return new Promise((resolve)=>setTimeout(resolve, time));
}
function $be0f210bba242519$export$1e0f363384bbe072() {
    if (window.__sentry__ && window.__sentry__.relay) return window.__sentry__.relay;
    let relay = "";
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("relay")) relay = searchParams.get("relay");
    else relay = $be0f210bba242519$export$2f3ffc2e7c480193();
    $be0f210bba242519$export$3497527809e7dcd3({
        relay: relay
    });
    return relay;
}
function $be0f210bba242519$export$2f3ffc2e7c480193() {
    const randomBytes = new Uint8Array(16);
    crypto.getRandomValues(randomBytes);
    randomBytes[6] = randomBytes[6] & 0x0f | 0x40; // Set version to 4 (0100)
    randomBytes[8] = randomBytes[8] & 0x3f | 0x80; // Set variant to 1 (10)
    const toHex = (n)=>n.toString(16).padStart(2, "0");
    const byteToHex = Array.from(randomBytes, toHex);
    const relay = [
        ...byteToHex.slice(0, 4),
        "-",
        ...byteToHex.slice(4, 6),
        "-",
        ...byteToHex.slice(6, 8),
        "-",
        ...byteToHex.slice(8, 10),
        "-",
        ...byteToHex.slice(10)
    ].join("");
    return relay;
}
function $be0f210bba242519$export$4ef9c1cc8696d2de(platform) {
    return platform === "ios" ? window.webkit.messageHandlers.Sentry : window.Sentry;
}
function $be0f210bba242519$export$58da9968c3170cb1(error) {
    const variant = document.location.hash.substring(1);
    const { logError: errorLogger } = (0, $gigCS.getLoggers)();
    if (error && typeof error === "object" && error.toString) {
        errorLogger({
            error: error,
            variant: variant !== null && variant !== void 0 ? variant : "undefined"
        });
        console.error(error.toString());
    } else {
        errorLogger({
            error: error,
            variant: variant !== null && variant !== void 0 ? variant : "undefined"
        });
        console.error(error);
    }
}
function $be0f210bba242519$export$2584992308717284(error) {
    const variant = document.location.hash.substring(1);
    const { logCritical: criticalLogger } = (0, $gigCS.getLoggers)();
    criticalLogger({
        error: error,
        variant: variant !== null && variant !== void 0 ? variant : "undefined"
    });
    console.error(error.toString());
}
function $be0f210bba242519$export$89c0607256d35f0a(info, meta) {
    const variant = document.location.hash.substring(1);
    const { logInfo: infoLogger } = (0, $gigCS.getLoggers)();
    infoLogger({
        info: info,
        meta: meta,
        variant: variant !== null && variant !== void 0 ? variant : "undefined"
    });
    console.info(info, meta);
}
function $be0f210bba242519$export$2e7125f6dc82fcb4(resp) {
    return JSON.stringify({
        status: resp.status,
        statusText: resp.statusText
    });
}
function $be0f210bba242519$export$d4c835785770a710(error) {
    const params = new URLSearchParams(document.location.search.substring(1));
    var _params_get;
    if (params.get("wrapper") === "false") $be0f210bba242519$export$4ef9c1cc8696d2de(params.get("platform")).postMessage(JSON.stringify({
        side: "proxy",
        name: "on-error",
        data: {
            name: (0, $jirw5.ERROR_REASONS).unrecoverable
        }
    }));
    else window.parent.postMessage(JSON.stringify({
        side: "app",
        name: "error",
        data: (0, $35vl8._)({
            name: (0, $jirw5.ERROR_REASONS).unrecoverable
        }, error instanceof Error ? {
            stack: error.stack,
            message: error.message,
            cause: error.cause
        } : {})
    }), (_params_get = params.get("asserted_origin")) !== null && _params_get !== void 0 ? _params_get : "*");
    $be0f210bba242519$export$58da9968c3170cb1(error);
}
function $be0f210bba242519$export$8df1f63844fe00cd(obj) {
    const [firstKey, ...otherKeys] = Object.keys(obj);
    return (0, $3BQJL.z).enum([
        firstKey,
        ...otherKeys
    ]);
}
const $be0f210bba242519$export$fdf252fdc56190c3 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);

});
parcelRegister("8Tavf", function(module, exports) {
$parcel$export(module.exports, "sanitizeLocale", () => (parcelRequire("4S9FR")).sanitizeLocale);
$parcel$export(module.exports, "i18n", () => (parcelRequire("8wZEr")).i18n);
$parcel$export(module.exports, "i18nLoading", () => (parcelRequire("8wZEr")).i18nLoading);
$parcel$export(module.exports, "initLocalisation", () => (parcelRequire("8wZEr")).initLocalisation);
parcelRequire("4S9FR");
parcelRequire("8wZEr");

var $ecqGY = parcelRequire("ecqGY");
$parcel$exportWildcard(module.exports, $ecqGY);

});
parcelRegister("4S9FR", function(module, exports) {

$parcel$export(module.exports, "sanitizeLocale", () => $272ebc07e73f9145$export$3750284cd7e8bdf9);

var $61jWn = parcelRequire("61jWn");
const $272ebc07e73f9145$var$defaultLocalesByLanguage = [
    "en-us",
    "es-es",
    "fr-fr",
    "sr-rs",
    "zh-cn"
];
function $272ebc07e73f9145$export$3750284cd7e8bdf9(val) {
    // transforms fr_FR to fr-FR
    let updatedVal = val.replace("_", "-");
    //transforms fr-FR to fr-fr
    updatedVal = updatedVal.toLowerCase();
    if ((0, $61jWn.allLocales).includes(updatedVal)) return updatedVal;
    // extracts fr from fr-jp
    const language = updatedVal.split("-")[0];
    // finds the default locale for the language
    const countryLocale = $272ebc07e73f9145$var$defaultLocalesByLanguage.find((l)=>l.startsWith(language)) || (0, $61jWn.allLocales).find((l)=>l.startsWith(language));
    if (countryLocale) {
        console.warn(`The provided locale is unsupported. Using '${countryLocale}' locale instead.`);
        return countryLocale;
    }
    // if nothing is found, return en-us
    console.warn(`The provided locale is unsupported. Using 'en-us' locale instead.`);
    return "en-us";
}

});
parcelRegister("61jWn", function(module, exports) {

$parcel$export(module.exports, "allLocales", () => $f46919f100f2c004$export$70e81b5f5f7c5b5e);
/**
 * The locale code that templates in this source code are written in.
 */ const $f46919f100f2c004$export$39ee57b29e1d3664 = `en-us`;
const $f46919f100f2c004$export$70e81b5f5f7c5b5e = [
    "bg-bg",
    "cs-cz",
    "da-dk",
    "de-de",
    "el-gr",
    "en-ae",
    "en-gb",
    "en-hr",
    "en-il",
    "en-ke",
    "en-lk",
    "en-mo",
    "en-mu",
    "en-ng",
    "en-tt",
    "en-us",
    "en-vn",
    "en-xm",
    "es-bo",
    "es-do",
    "es-es",
    "es-la",
    "es-mx",
    "es-na",
    "es-pa",
    "es-py",
    "es-sv",
    "es-uy",
    "et-ee",
    "fi-fi",
    "fil-ph",
    "fr-ca",
    "fr-fr",
    "fr-ma",
    "fr-xm",
    "hr-hr",
    "hu-hu",
    "id-id",
    "it-it",
    "ja-jp",
    "ko-kr",
    "lt-lt",
    "lv-lv",
    "nb-no",
    "nl-nl",
    "ms-my",
    "pl-pl",
    "pt-br",
    "ro-ro",
    "ru-ru",
    "sk-sk",
    "sl-si",
    "sr-rs",
    "sr-sp",
    "sv-se",
    "th-th",
    "tr-tr",
    "uk-ua",
    "vi-vn",
    "zh-cn",
    "zh-hans",
    "zh-hant",
    "zh-mo",
    "zh-tw"
];

});


parcelRegister("8wZEr", function(module, exports) {

$parcel$export(module.exports, "initLocalisation", () => $87c7812a51a3debf$export$d90c493c56e19e3d);
$parcel$export(module.exports, "i18nLoading", () => $87c7812a51a3debf$export$6d19c5298d32f31e);
$parcel$export(module.exports, "i18n", () => $87c7812a51a3debf$export$a7357cdd1f0b0168);

var $dHnPu = parcelRequire("dHnPu");

var $61GbW = parcelRequire("61GbW");
var $9u67C = parcelRequire("9u67C");

var $gngI6 = parcelRequire("gngI6");
const $87c7812a51a3debf$export$f4aedcd5bab7e55e = (0, $gngI6.createStore)(()=>({
        intl: (0, $61GbW.createIntl)({
            locale: "en-us",
            messages: {}
        }),
        loading: true,
        loadingPromise: null
    }));
function $87c7812a51a3debf$var$initIntl({ locale: locale, messages: messages }) {
    return new Promise((resolve)=>{
        const intlCache = (0, $9u67C.createIntlCache)();
        const intl = (0, $61GbW.createIntl)({
            locale: locale,
            messages: messages
        }, intlCache);
        resolve(intl);
    });
}
function $87c7812a51a3debf$export$d90c493c56e19e3d(locale) {
    return $87c7812a51a3debf$var$_initLocalisation.apply(this, arguments);
}
function $87c7812a51a3debf$var$_initLocalisation() {
    $87c7812a51a3debf$var$_initLocalisation = (0, $dHnPu._)(function*(locale) {
        const loadingPromise = fetch(`/locales/${locale}.json`).then((res)=>res.json()).then((messages)=>$87c7812a51a3debf$var$initIntl({
                locale: locale,
                messages: messages
            }));
        $87c7812a51a3debf$export$f4aedcd5bab7e55e.setState({
            loadingPromise: loadingPromise
        });
        const intl = yield loadingPromise;
        $87c7812a51a3debf$export$f4aedcd5bab7e55e.setState({
            intl: intl,
            loading: false
        });
    });
    return $87c7812a51a3debf$var$_initLocalisation.apply(this, arguments);
}
const $87c7812a51a3debf$export$6d19c5298d32f31e = ()=>({
        isLocaleLoading: $87c7812a51a3debf$export$f4aedcd5bab7e55e.getState().loading,
        localeLoadingPromise: $87c7812a51a3debf$export$f4aedcd5bab7e55e.getState().loadingPromise
    });
const $87c7812a51a3debf$export$a7357cdd1f0b0168 = ()=>$87c7812a51a3debf$export$f4aedcd5bab7e55e.getState().intl;

});
parcelRegister("61GbW", function(module, exports) {

$parcel$export(module.exports, "createIntl", () => $46339074b5836c4e$export$7e4cbedfdd7b4c0d);

var $3BqCE = parcelRequire("3BqCE");

var $9u67C = parcelRequire("9u67C");

var $cig2T = parcelRequire("cig2T");

var $2qkLW = parcelRequire("2qkLW");

var $90vQ8 = parcelRequire("90vQ8");

var $7kYd5 = parcelRequire("7kYd5");

var $7KhNo = parcelRequire("7KhNo");

var $4OWEW = parcelRequire("4OWEW");

var $3Vy2X = parcelRequire("3Vy2X");

var $ijUuE = parcelRequire("ijUuE");
function $46339074b5836c4e$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $46339074b5836c4e$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $46339074b5836c4e$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function $46339074b5836c4e$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $9u67C.createFormatters)(cache);
    var resolvedConfig = (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, (0, $9u67C.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $cig2T.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $cig2T.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $cig2T.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $46339074b5836c4e$var$verifyConfigMessages(resolvedConfig);
    return (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $2qkLW.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $2qkLW.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $90vQ8.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $7kYd5.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $7kYd5.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $7kYd5.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $7kYd5.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $7kYd5.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $7KhNo.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $4OWEW.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $4OWEW.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $3Vy2X.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $3Vy2X.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $ijUuE.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("3BqCE", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $29f97a72c2de9725$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $29f97a72c2de9725$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $29f97a72c2de9725$export$3c9a16f847548506);
$parcel$export(module.exports, "__decorate", () => $29f97a72c2de9725$export$29e00dfd3077644b);
$parcel$export(module.exports, "__spreadArray", () => $29f97a72c2de9725$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $29f97a72c2de9725$var$extendStatics = function(d, b) {
    $29f97a72c2de9725$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $29f97a72c2de9725$var$extendStatics(d, b);
};
function $29f97a72c2de9725$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $29f97a72c2de9725$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $29f97a72c2de9725$export$18ce0697a983be9b = function() {
    $29f97a72c2de9725$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $29f97a72c2de9725$export$18ce0697a983be9b.apply(this, arguments);
};
function $29f97a72c2de9725$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $29f97a72c2de9725$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $29f97a72c2de9725$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $29f97a72c2de9725$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $29f97a72c2de9725$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $29f97a72c2de9725$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $29f97a72c2de9725$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $29f97a72c2de9725$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $29f97a72c2de9725$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $29f97a72c2de9725$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $29f97a72c2de9725$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $29f97a72c2de9725$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $29f97a72c2de9725$export$45d3717a4c69092e(o, m, p);
}
function $29f97a72c2de9725$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $29f97a72c2de9725$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $29f97a72c2de9725$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($29f97a72c2de9725$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $29f97a72c2de9725$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $29f97a72c2de9725$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $29f97a72c2de9725$export$10c90e4f7922046c(v) {
    return this instanceof $29f97a72c2de9725$export$10c90e4f7922046c ? (this.v = v, this) : new $29f97a72c2de9725$export$10c90e4f7922046c(v);
}
function $29f97a72c2de9725$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $29f97a72c2de9725$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $29f97a72c2de9725$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $29f97a72c2de9725$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $29f97a72c2de9725$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $29f97a72c2de9725$export$19a8beecd37a4c45 === "function" ? $29f97a72c2de9725$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $29f97a72c2de9725$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $29f97a72c2de9725$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $29f97a72c2de9725$var$ownKeys = function(o) {
    $29f97a72c2de9725$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $29f97a72c2de9725$var$ownKeys(o);
};
function $29f97a72c2de9725$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $29f97a72c2de9725$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $29f97a72c2de9725$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $29f97a72c2de9725$var$__setModuleDefault(result, mod);
    return result;
}
function $29f97a72c2de9725$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $29f97a72c2de9725$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $29f97a72c2de9725$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $29f97a72c2de9725$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $29f97a72c2de9725$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $29f97a72c2de9725$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $29f97a72c2de9725$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $29f97a72c2de9725$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $29f97a72c2de9725$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $29f97a72c2de9725$export$2e2bcd8739ae039 = {
    __extends: $29f97a72c2de9725$export$a8ba968b8961cb8a,
    __assign: $29f97a72c2de9725$export$18ce0697a983be9b,
    __rest: $29f97a72c2de9725$export$3c9a16f847548506,
    __decorate: $29f97a72c2de9725$export$29e00dfd3077644b,
    __param: $29f97a72c2de9725$export$d5ad3fd78186038f,
    __esDecorate: $29f97a72c2de9725$export$3a84e1ae4e97e9b0,
    __runInitializers: $29f97a72c2de9725$export$d831c04e792af3d,
    __propKey: $29f97a72c2de9725$export$6a2a36740a146cb8,
    __setFunctionName: $29f97a72c2de9725$export$d1a06452d3489bc7,
    __metadata: $29f97a72c2de9725$export$f1db080c865becb9,
    __awaiter: $29f97a72c2de9725$export$1050f835b63b671e,
    __generator: $29f97a72c2de9725$export$67ebef60e6f28a6,
    __createBinding: $29f97a72c2de9725$export$45d3717a4c69092e,
    __exportStar: $29f97a72c2de9725$export$f33643c0debef087,
    __values: $29f97a72c2de9725$export$19a8beecd37a4c45,
    __read: $29f97a72c2de9725$export$8d051b38c9118094,
    __spread: $29f97a72c2de9725$export$afc72e2116322959,
    __spreadArrays: $29f97a72c2de9725$export$6388937ca91ccae8,
    __spreadArray: $29f97a72c2de9725$export$1216008129fb82ed,
    __await: $29f97a72c2de9725$export$10c90e4f7922046c,
    __asyncGenerator: $29f97a72c2de9725$export$e427f37a30a4de9b,
    __asyncDelegator: $29f97a72c2de9725$export$bbd80228419bb833,
    __asyncValues: $29f97a72c2de9725$export$e3b29a3d6162315f,
    __makeTemplateObject: $29f97a72c2de9725$export$4fb47efe1390b86f,
    __importStar: $29f97a72c2de9725$export$c21735bcef00d192,
    __importDefault: $29f97a72c2de9725$export$da59b14a69baef04,
    __classPrivateFieldGet: $29f97a72c2de9725$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $29f97a72c2de9725$export$d40a35129aaff81f,
    __classPrivateFieldIn: $29f97a72c2de9725$export$81fdc39f203e4e04,
    __addDisposableResource: $29f97a72c2de9725$export$88ac25d8e944e405,
    __disposeResources: $29f97a72c2de9725$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $29f97a72c2de9725$export$889dfb5d17574b0b
};

});

parcelRegister("9u67C", function(module, exports) {

$parcel$export(module.exports, "filterProps", () => $6e7baa0dbb3fe497$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $6e7baa0dbb3fe497$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $6e7baa0dbb3fe497$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $6e7baa0dbb3fe497$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $6e7baa0dbb3fe497$export$4ee1db8ce44a209b);

var $3BqCE = parcelRequire("3BqCE");

var $6DmLQ = parcelRequire("6DmLQ");

var $lSLfb = parcelRequire("lSLfb");

var $cig2T = parcelRequire("cig2T");
function $6e7baa0dbb3fe497$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $6e7baa0dbb3fe497$var$defaultErrorHandler = function(error) {};
var $6e7baa0dbb3fe497$var$defaultWarnHandler = function(warning) {};
var $6e7baa0dbb3fe497$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $6e7baa0dbb3fe497$var$defaultErrorHandler,
    onWarn: $6e7baa0dbb3fe497$var$defaultWarnHandler
};
function $6e7baa0dbb3fe497$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $6e7baa0dbb3fe497$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $6e7baa0dbb3fe497$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $6e7baa0dbb3fe497$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $lSLfb.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $3BqCE.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $6e7baa0dbb3fe497$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $lSLfb.strategies).variadic
    });
    var getNumberFormat = (0, $lSLfb.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $3BqCE.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $6e7baa0dbb3fe497$var$createFastMemoizeCache(cache.number),
        strategy: (0, $lSLfb.strategies).variadic
    });
    var getPluralRules = (0, $lSLfb.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $3BqCE.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $6e7baa0dbb3fe497$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $lSLfb.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $lSLfb.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $6DmLQ.IntlMessageFormat)(message, locales, overrideFormats, (0, $3BqCE.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $6e7baa0dbb3fe497$var$createFastMemoizeCache(cache.message),
            strategy: (0, $lSLfb.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $lSLfb.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $3BqCE.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6e7baa0dbb3fe497$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $lSLfb.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $lSLfb.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $3BqCE.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6e7baa0dbb3fe497$var$createFastMemoizeCache(cache.list),
            strategy: (0, $lSLfb.strategies).variadic
        }),
        getDisplayNames: (0, $lSLfb.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $3BqCE.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6e7baa0dbb3fe497$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $lSLfb.strategies).variadic
        })
    };
}
function $6e7baa0dbb3fe497$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $cig2T.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("6DmLQ", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", () => $4d480c5d9919feb4$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $3BqCE = parcelRequire("3BqCE");

var $1umtk = parcelRequire("1umtk");

var $lSLfb = parcelRequire("lSLfb");

var $cykCi = parcelRequire("cykCi");
// -- MessageFormat --------------------------------------------------------
function $4d480c5d9919feb4$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $3BqCE.__assign)((0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $4d480c5d9919feb4$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $4d480c5d9919feb4$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $3BqCE.__assign)({}, defaultConfig));
}
function $4d480c5d9919feb4$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $4d480c5d9919feb4$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $lSLfb.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $3BqCE.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4d480c5d9919feb4$var$createFastMemoizeCache(cache.number),
            strategy: (0, $lSLfb.strategies).variadic
        }),
        getDateTimeFormat: (0, $lSLfb.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $3BqCE.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4d480c5d9919feb4$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $lSLfb.strategies).variadic
        }),
        getPluralRules: (0, $lSLfb.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $3BqCE.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4d480c5d9919feb4$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $lSLfb.strategies).variadic
        })
    };
}
var $4d480c5d9919feb4$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $cykCi.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $cykCi.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $3BqCE.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $4d480c5d9919feb4$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $4d480c5d9919feb4$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $1umtk.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("1umtk", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("4rOHW")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("4rOHW")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("4rOHW")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("4rOHW")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("4rOHW")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("4rOHW")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("4rOHW")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("4rOHW")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("4rOHW")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("4rOHW")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("4rOHW")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("4rOHW")).TYPE);

$parcel$export(module.exports, "parse", () => $115a0644d23df5f0$export$98e6a39c04603d36);

var $3BqCE = parcelRequire("3BqCE");

var $122fC = parcelRequire("122fC");

var $dSAck = parcelRequire("dSAck");

var $4rOHW = parcelRequire("4rOHW");
function $115a0644d23df5f0$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $4rOHW.isSelectElement)(el) || (0, $4rOHW.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $115a0644d23df5f0$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $4rOHW.isNumberElement)(el) && (0, $4rOHW.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $4rOHW.isDateElement)(el) || (0, $4rOHW.isTimeElement)(el)) && (0, $4rOHW.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $4rOHW.isTagElement)(el)) $115a0644d23df5f0$var$pruneLocation(el.children);
    });
}
function $115a0644d23df5f0$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $3BqCE.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $dSAck.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $122fC.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $115a0644d23df5f0$var$pruneLocation(result.val);
    return result.val;
}
var $115a0644d23df5f0$export$d3c1bfa0f7d806e9 = (0, $dSAck.Parser);

});
parcelRegister("122fC", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", () => $0c07b958189207c4$export$896afd8541959ee5);
var $0c07b958189207c4$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($0c07b958189207c4$export$896afd8541959ee5 || ($0c07b958189207c4$export$896afd8541959ee5 = {}));

});

parcelRegister("dSAck", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $a1ac65a9eef1d5ca$export$7acfa6ed01010e37);

var $3BqCE = parcelRequire("3BqCE");

var $122fC = parcelRequire("122fC");

var $4rOHW = parcelRequire("4rOHW");

var $gdyTD = parcelRequire("gdyTD");
parcelRequire("hE6xs");
var $kZmRs = parcelRequire("kZmRs");
var $12Sp1 = parcelRequire("12Sp1");

var $kjMkB = parcelRequire("kjMkB");
var $a1ac65a9eef1d5ca$var$_a;
var $a1ac65a9eef1d5ca$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $gdyTD.SPACE_SEPARATOR_REGEX).source, "*"));
var $a1ac65a9eef1d5ca$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $gdyTD.SPACE_SEPARATOR_REGEX).source, "*$"));
function $a1ac65a9eef1d5ca$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $a1ac65a9eef1d5ca$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $a1ac65a9eef1d5ca$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $a1ac65a9eef1d5ca$var$hasNativeFromEntries = !!Object.fromEntries;
var $a1ac65a9eef1d5ca$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $a1ac65a9eef1d5ca$var$hasTrimStart = !!String.prototype.trimStart;
var $a1ac65a9eef1d5ca$var$hasTrimEnd = !!String.prototype.trimEnd;
var $a1ac65a9eef1d5ca$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $a1ac65a9eef1d5ca$var$isSafeInteger = $a1ac65a9eef1d5ca$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $a1ac65a9eef1d5ca$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $a1ac65a9eef1d5ca$var$re = $a1ac65a9eef1d5ca$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $a1ac65a9eef1d5ca$var$REGEX_SUPPORTS_U_AND_Y = (($a1ac65a9eef1d5ca$var$_a = $a1ac65a9eef1d5ca$var$re.exec("a")) === null || $a1ac65a9eef1d5ca$var$_a === void 0 ? void 0 : $a1ac65a9eef1d5ca$var$_a[0]) === "a";
} catch (_) {
    $a1ac65a9eef1d5ca$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $a1ac65a9eef1d5ca$var$startsWith = $a1ac65a9eef1d5ca$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $a1ac65a9eef1d5ca$var$fromCodePoint = $a1ac65a9eef1d5ca$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $a1ac65a9eef1d5ca$var$fromEntries = // native
$a1ac65a9eef1d5ca$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $a1ac65a9eef1d5ca$var$codePointAt = $a1ac65a9eef1d5ca$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $a1ac65a9eef1d5ca$var$trimStart = $a1ac65a9eef1d5ca$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($a1ac65a9eef1d5ca$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $a1ac65a9eef1d5ca$var$trimEnd = $a1ac65a9eef1d5ca$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($a1ac65a9eef1d5ca$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $a1ac65a9eef1d5ca$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $a1ac65a9eef1d5ca$var$matchIdentifierAtIndex;
if ($a1ac65a9eef1d5ca$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $a1ac65a9eef1d5ca$var$IDENTIFIER_PREFIX_RE_1 = $a1ac65a9eef1d5ca$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $a1ac65a9eef1d5ca$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $a1ac65a9eef1d5ca$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $a1ac65a9eef1d5ca$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$a1ac65a9eef1d5ca$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $a1ac65a9eef1d5ca$var$codePointAt(s, index);
        if (c === undefined || $a1ac65a9eef1d5ca$var$_isWhiteSpace(c) || $a1ac65a9eef1d5ca$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $a1ac65a9eef1d5ca$var$fromCodePoint.apply(void 0, match);
};
var $a1ac65a9eef1d5ca$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $4rOHW.TYPE).pound,
                    location: $a1ac65a9eef1d5ca$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $122fC.ErrorKind).UNMATCHED_CLOSING_TAG, $a1ac65a9eef1d5ca$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $a1ac65a9eef1d5ca$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $4rOHW.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $a1ac65a9eef1d5ca$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$a1ac65a9eef1d5ca$var$_isAlpha(this.char())) return this.error((0, $122fC.ErrorKind).INVALID_TAG, $a1ac65a9eef1d5ca$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $122fC.ErrorKind).UNMATCHED_CLOSING_TAG, $a1ac65a9eef1d5ca$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $122fC.ErrorKind).INVALID_TAG, $a1ac65a9eef1d5ca$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $4rOHW.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $a1ac65a9eef1d5ca$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $122fC.ErrorKind).UNCLOSED_TAG, $a1ac65a9eef1d5ca$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $122fC.ErrorKind).INVALID_TAG, $a1ac65a9eef1d5ca$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $a1ac65a9eef1d5ca$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $a1ac65a9eef1d5ca$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $4rOHW.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$a1ac65a9eef1d5ca$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $a1ac65a9eef1d5ca$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $a1ac65a9eef1d5ca$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $122fC.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $a1ac65a9eef1d5ca$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $122fC.ErrorKind).EMPTY_ARGUMENT, $a1ac65a9eef1d5ca$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $122fC.ErrorKind).MALFORMED_ARGUMENT, $a1ac65a9eef1d5ca$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $122fC.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $a1ac65a9eef1d5ca$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $4rOHW.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $a1ac65a9eef1d5ca$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $122fC.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $a1ac65a9eef1d5ca$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $122fC.ErrorKind).MALFORMED_ARGUMENT, $a1ac65a9eef1d5ca$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $a1ac65a9eef1d5ca$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $a1ac65a9eef1d5ca$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $122fC.ErrorKind).EXPECT_ARGUMENT_TYPE, $a1ac65a9eef1d5ca$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $a1ac65a9eef1d5ca$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $122fC.ErrorKind).EXPECT_ARGUMENT_STYLE, $a1ac65a9eef1d5ca$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $a1ac65a9eef1d5ca$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $a1ac65a9eef1d5ca$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $a1ac65a9eef1d5ca$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $a1ac65a9eef1d5ca$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $4rOHW.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $122fC.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $kjMkB.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $4rOHW.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $kZmRs.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $4rOHW.TYPE).date : (0, $4rOHW.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $4rOHW.TYPE).number : argType === "date" ? (0, $4rOHW.TYPE).date : (0, $4rOHW.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $122fC.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $a1ac65a9eef1d5ca$var$createLocation(typeEndPosition_1, (0, $3BqCE.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $122fC.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $a1ac65a9eef1d5ca$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $122fC.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $122fC.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $a1ac65a9eef1d5ca$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $4rOHW.TYPE).select,
                        value: value,
                        options: $a1ac65a9eef1d5ca$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $4rOHW.TYPE).plural,
                        value: value,
                        options: $a1ac65a9eef1d5ca$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $122fC.ErrorKind).INVALID_ARGUMENT_TYPE, $a1ac65a9eef1d5ca$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $122fC.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $a1ac65a9eef1d5ca$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $122fC.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $a1ac65a9eef1d5ca$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $12Sp1.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $122fC.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $4rOHW.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $12Sp1.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $122fC.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $122fC.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $a1ac65a9eef1d5ca$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $122fC.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $122fC.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $122fC.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $122fC.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $a1ac65a9eef1d5ca$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $a1ac65a9eef1d5ca$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $122fC.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $122fC.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $a1ac65a9eef1d5ca$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $122fC.ErrorKind).MISSING_OTHER_CLAUSE, $a1ac65a9eef1d5ca$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $a1ac65a9eef1d5ca$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$a1ac65a9eef1d5ca$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $a1ac65a9eef1d5ca$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($a1ac65a9eef1d5ca$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $a1ac65a9eef1d5ca$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $a1ac65a9eef1d5ca$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $a1ac65a9eef1d5ca$var$_isAlphaOrSlash(codepoint) {
    return $a1ac65a9eef1d5ca$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $a1ac65a9eef1d5ca$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $a1ac65a9eef1d5ca$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $a1ac65a9eef1d5ca$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("4rOHW", function(module, exports) {

$parcel$export(module.exports, "TYPE", () => $33d1048fecfd9916$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $33d1048fecfd9916$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $33d1048fecfd9916$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $33d1048fecfd9916$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $33d1048fecfd9916$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $33d1048fecfd9916$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $33d1048fecfd9916$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $33d1048fecfd9916$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $33d1048fecfd9916$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $33d1048fecfd9916$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $33d1048fecfd9916$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $33d1048fecfd9916$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $33d1048fecfd9916$export$7680c41f1a55f4cf);
var $33d1048fecfd9916$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($33d1048fecfd9916$export$b87f371cbc396fcf || ($33d1048fecfd9916$export$b87f371cbc396fcf = {}));
var $33d1048fecfd9916$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($33d1048fecfd9916$export$906452485466fa53 || ($33d1048fecfd9916$export$906452485466fa53 = {}));
function $33d1048fecfd9916$export$cfa10c5697238752(el) {
    return el.type === $33d1048fecfd9916$export$b87f371cbc396fcf.literal;
}
function $33d1048fecfd9916$export$4f55724281bdfaf9(el) {
    return el.type === $33d1048fecfd9916$export$b87f371cbc396fcf.argument;
}
function $33d1048fecfd9916$export$e11187b219e191e1(el) {
    return el.type === $33d1048fecfd9916$export$b87f371cbc396fcf.number;
}
function $33d1048fecfd9916$export$32d811605da75f40(el) {
    return el.type === $33d1048fecfd9916$export$b87f371cbc396fcf.date;
}
function $33d1048fecfd9916$export$34ec46f596b1702f(el) {
    return el.type === $33d1048fecfd9916$export$b87f371cbc396fcf.time;
}
function $33d1048fecfd9916$export$dcfe1c11d168b5a1(el) {
    return el.type === $33d1048fecfd9916$export$b87f371cbc396fcf.select;
}
function $33d1048fecfd9916$export$6c796d116f0a4fbc(el) {
    return el.type === $33d1048fecfd9916$export$b87f371cbc396fcf.plural;
}
function $33d1048fecfd9916$export$c0ece297bdd0c082(el) {
    return el.type === $33d1048fecfd9916$export$b87f371cbc396fcf.pound;
}
function $33d1048fecfd9916$export$5c83de34745812b(el) {
    return el.type === $33d1048fecfd9916$export$b87f371cbc396fcf.tag;
}
function $33d1048fecfd9916$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $33d1048fecfd9916$export$906452485466fa53.number);
}
function $33d1048fecfd9916$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $33d1048fecfd9916$export$906452485466fa53.dateTime);
}
function $33d1048fecfd9916$export$f0ac572c1121c662(value) {
    return {
        type: $33d1048fecfd9916$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $33d1048fecfd9916$export$425e864b0ba114f1(value, style) {
    return {
        type: $33d1048fecfd9916$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("gdyTD", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $bce8ededa17de930$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $bce8ededa17de930$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $bce8ededa17de930$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("hE6xs", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("kZmRs")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("12Sp1")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("12Sp1")).parseNumberSkeletonFromString);
parcelRequire("kZmRs");
parcelRequire("12Sp1");

});
parcelRegister("kZmRs", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", () => $f47b3ceb6b35c92e$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $f47b3ceb6b35c92e$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $f47b3ceb6b35c92e$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($f47b3ceb6b35c92e$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("12Sp1", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $0c302d938cedb203$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $0c302d938cedb203$export$47c6f8480bda3e11);

var $3BqCE = parcelRequire("3BqCE");

var $hqVDr = parcelRequire("hqVDr");
function $0c302d938cedb203$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $hqVDr.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $0c302d938cedb203$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $0c302d938cedb203$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $0c302d938cedb203$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $0c302d938cedb203$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $0c302d938cedb203$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $0c302d938cedb203$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($0c302d938cedb203$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $0c302d938cedb203$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $0c302d938cedb203$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$0c302d938cedb203$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $0c302d938cedb203$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $0c302d938cedb203$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $0c302d938cedb203$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $0c302d938cedb203$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $3BqCE.__assign)((0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, all), $0c302d938cedb203$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $3BqCE.__assign)((0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, all), $0c302d938cedb203$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($0c302d938cedb203$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($0c302d938cedb203$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($0c302d938cedb203$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($0c302d938cedb203$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, result), $0c302d938cedb203$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($0c302d938cedb203$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, result), $0c302d938cedb203$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $0c302d938cedb203$var$parseSign(token.stem);
        if (signOpts) result = (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $0c302d938cedb203$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("hqVDr", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $cb119284b8047e94$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $cb119284b8047e94$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("kjMkB", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", () => $ecab1299c6a4b319$export$29c5368be8904d27);

var $e6LwR = parcelRequire("e6LwR");
function $ecab1299c6a4b319$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $ecab1299c6a4b319$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $ecab1299c6a4b319$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $e6LwR.timeData)[regionTag || ""] || (0, $e6LwR.timeData)[languageTag || ""] || (0, $e6LwR.timeData)["".concat(languageTag, "-001")] || (0, $e6LwR.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("e6LwR", function(module, exports) {

$parcel$export(module.exports, "timeData", () => $a4567e80dfe3c835$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $a4567e80dfe3c835$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("lSLfb", function(module, exports) {

$parcel$export(module.exports, "memoize", () => $fee349bfeb34e0d9$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $fee349bfeb34e0d9$export$c5491a8691a23b9e);
//
// Main
//
function $fee349bfeb34e0d9$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $fee349bfeb34e0d9$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $fee349bfeb34e0d9$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $fee349bfeb34e0d9$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $fee349bfeb34e0d9$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $fee349bfeb34e0d9$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $fee349bfeb34e0d9$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $fee349bfeb34e0d9$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $fee349bfeb34e0d9$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $fee349bfeb34e0d9$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $fee349bfeb34e0d9$var$monadic : $fee349bfeb34e0d9$var$variadic;
    return $fee349bfeb34e0d9$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $fee349bfeb34e0d9$var$strategyVariadic(fn, options) {
    return $fee349bfeb34e0d9$var$assemble(fn, this, $fee349bfeb34e0d9$var$variadic, options.cache.create(), options.serializer);
}
function $fee349bfeb34e0d9$var$strategyMonadic(fn, options) {
    return $fee349bfeb34e0d9$var$assemble(fn, this, $fee349bfeb34e0d9$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $fee349bfeb34e0d9$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $fee349bfeb34e0d9$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$fee349bfeb34e0d9$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$fee349bfeb34e0d9$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $fee349bfeb34e0d9$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $fee349bfeb34e0d9$var$ObjectWithoutPrototypeCache();
    }
};
var $fee349bfeb34e0d9$export$c5491a8691a23b9e = {
    variadic: $fee349bfeb34e0d9$var$strategyVariadic,
    monadic: $fee349bfeb34e0d9$var$strategyMonadic
};

});

parcelRegister("cykCi", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", () => $9238a71421cc202c$export$49694c2877b44c57);
$parcel$export(module.exports, "formatToParts", () => $9238a71421cc202c$export$275d4a3bb5f66fda);
parcelRequire("1umtk");
var $4rOHW = parcelRequire("4rOHW");

var $1iLes = parcelRequire("1iLes");
var $9238a71421cc202c$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($9238a71421cc202c$export$49694c2877b44c57 || ($9238a71421cc202c$export$49694c2877b44c57 = {}));
function $9238a71421cc202c$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $9238a71421cc202c$export$49694c2877b44c57.literal || part.type !== $9238a71421cc202c$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $9238a71421cc202c$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $9238a71421cc202c$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $4rOHW.isLiteralElement)(els[0])) return [
        {
            type: $9238a71421cc202c$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $4rOHW.isLiteralElement)(el)) {
            result.push({
                type: $9238a71421cc202c$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $4rOHW.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $9238a71421cc202c$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $1iLes.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $4rOHW.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $9238a71421cc202c$export$49694c2877b44c57.literal : $9238a71421cc202c$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $4rOHW.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $4rOHW.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $9238a71421cc202c$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4rOHW.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $4rOHW.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $9238a71421cc202c$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4rOHW.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $4rOHW.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $9238a71421cc202c$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4rOHW.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$9238a71421cc202c$export$df0c12a2d414a163(formatFn)) throw new (0, $1iLes.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $9238a71421cc202c$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $9238a71421cc202c$export$49694c2877b44c57.literal : $9238a71421cc202c$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $4rOHW.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $1iLes.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $9238a71421cc202c$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $4rOHW.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $1iLes.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $1iLes.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $1iLes.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $9238a71421cc202c$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $9238a71421cc202c$var$mergeLiteral(result);
}

});
parcelRegister("1iLes", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", () => $0f2c1c3762914a25$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $0f2c1c3762914a25$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $0f2c1c3762914a25$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $0f2c1c3762914a25$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $0f2c1c3762914a25$export$8bfc137e4d23fdf0);

var $3BqCE = parcelRequire("3BqCE");
var $0f2c1c3762914a25$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($0f2c1c3762914a25$export$d4e71bc0b80dc0fb || ($0f2c1c3762914a25$export$d4e71bc0b80dc0fb = {}));
var $0f2c1c3762914a25$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $3BqCE.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $0f2c1c3762914a25$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $3BqCE.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $0f2c1c3762914a25$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($0f2c1c3762914a25$export$7369836851cc1329);
var $0f2c1c3762914a25$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $3BqCE.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $0f2c1c3762914a25$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($0f2c1c3762914a25$export$7369836851cc1329);
var $0f2c1c3762914a25$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $3BqCE.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $0f2c1c3762914a25$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($0f2c1c3762914a25$export$7369836851cc1329);

});



parcelRegister("cig2T", function(module, exports) {

$parcel$export(module.exports, "UnsupportedFormatterError", () => $8f339cd15137f67e$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $8f339cd15137f67e$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $8f339cd15137f67e$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $8f339cd15137f67e$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $8f339cd15137f67e$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $8f339cd15137f67e$export$2ddcb436d0aa3688);

var $3BqCE = parcelRequire("3BqCE");
var $8f339cd15137f67e$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($8f339cd15137f67e$export$557d6acb76e8a244 || ($8f339cd15137f67e$export$557d6acb76e8a244 = {}));
var $8f339cd15137f67e$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $3BqCE.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $8f339cd15137f67e$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $3BqCE.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $8f339cd15137f67e$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($8f339cd15137f67e$export$c016d36112f6ddf8);
var $8f339cd15137f67e$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $3BqCE.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $8f339cd15137f67e$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($8f339cd15137f67e$export$c016d36112f6ddf8);
var $8f339cd15137f67e$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $3BqCE.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $8f339cd15137f67e$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($8f339cd15137f67e$export$c016d36112f6ddf8);
var $8f339cd15137f67e$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $3BqCE.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $8f339cd15137f67e$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($8f339cd15137f67e$export$c016d36112f6ddf8);
var $8f339cd15137f67e$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $3BqCE.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($8f339cd15137f67e$export$e3b7eee1dbc44895);
var $8f339cd15137f67e$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $3BqCE.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $8f339cd15137f67e$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($8f339cd15137f67e$export$c016d36112f6ddf8);

});


parcelRegister("2qkLW", function(module, exports) {

$parcel$export(module.exports, "formatNumber", () => $1c3e1f65d3862a05$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $1c3e1f65d3862a05$export$6871080848f10b2f);

var $9u67C = parcelRequire("9u67C");

var $cig2T = parcelRequire("cig2T");
var $1c3e1f65d3862a05$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function $1c3e1f65d3862a05$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $9u67C.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $9u67C.filterProps)(options, $1c3e1f65d3862a05$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $1c3e1f65d3862a05$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $1c3e1f65d3862a05$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $cig2T.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return String(value);
}
function $1c3e1f65d3862a05$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $1c3e1f65d3862a05$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $cig2T.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return [];
}

});

parcelRegister("90vQ8", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", () => $68eccfdb53124bbf$export$b4ea3b48dcf921f6);

var $9u67C = parcelRequire("9u67C");

var $1iLes = parcelRequire("1iLes");

var $cig2T = parcelRequire("cig2T");
var $68eccfdb53124bbf$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $68eccfdb53124bbf$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $9u67C.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $9u67C.filterProps)(options, $68eccfdb53124bbf$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $68eccfdb53124bbf$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $1iLes.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $1iLes.ErrorCode).MISSING_INTL_API));
    try {
        return $68eccfdb53124bbf$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $cig2T.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

});

parcelRegister("7kYd5", function(module, exports) {

$parcel$export(module.exports, "formatDate", () => $55791b2286c15f3f$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $55791b2286c15f3f$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $55791b2286c15f3f$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $55791b2286c15f3f$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $55791b2286c15f3f$export$af6e5d7a5c73edeb);

var $3BqCE = parcelRequire("3BqCE");

var $9u67C = parcelRequire("9u67C");

var $cig2T = parcelRequire("cig2T");
var $55791b2286c15f3f$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem",
    "fractionalSecondDigits"
];
function $55791b2286c15f3f$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $9u67C.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $9u67C.filterProps)(options, $55791b2286c15f3f$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $55791b2286c15f3f$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $55791b2286c15f3f$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $cig2T.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return String(date);
}
function $55791b2286c15f3f$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $55791b2286c15f3f$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $cig2T.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return String(date);
}
function $55791b2286c15f3f$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $9u67C.filterProps)(options, $55791b2286c15f3f$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $cig2T.IntlFormatError)("Error formatting date time range.", config.locale, e));
    }
    return String(from);
}
function $55791b2286c15f3f$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $55791b2286c15f3f$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $cig2T.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return [];
}
function $55791b2286c15f3f$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $55791b2286c15f3f$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $cig2T.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return [];
}

});

parcelRegister("7KhNo", function(module, exports) {

$parcel$export(module.exports, "formatPlural", () => $5a3aa223f9459e6d$export$bbbd05c900f3568d);

var $9u67C = parcelRequire("9u67C");

var $cig2T = parcelRequire("cig2T");

var $1iLes = parcelRequire("1iLes");
var $5a3aa223f9459e6d$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $5a3aa223f9459e6d$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $1iLes.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $1iLes.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $9u67C.filterProps)(options, $5a3aa223f9459e6d$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $cig2T.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

});

parcelRegister("4OWEW", function(module, exports) {

$parcel$export(module.exports, "formatMessage", () => $38295578cde97de1$export$25868d1e8e76735f);

var $3BqCE = parcelRequire("3BqCE");

var $4OESw = parcelRequire("4OESw");

var $6DmLQ = parcelRequire("6DmLQ");

var $cig2T = parcelRequire("cig2T");
parcelRequire("1umtk");
var $4rOHW = parcelRequire("4rOHW");
function $38295578cde97de1$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $3BqCE.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $38295578cde97de1$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $38295578cde97de1$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $6DmLQ.IntlMessageFormat).formats;
    return (0, $3BqCE.__assign)((0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, mfFormats), f1), {
        date: $38295578cde97de1$var$deepMergeOptions($38295578cde97de1$var$setTimeZoneInOptions(mfFormats.date, timeZone), $38295578cde97de1$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $38295578cde97de1$var$deepMergeOptions($38295578cde97de1$var$setTimeZoneInOptions(mfFormats.time, timeZone), $38295578cde97de1$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $38295578cde97de1$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $4OESw.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $4rOHW.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, defaultRichTextElements), values || {});
    formats = $38295578cde97de1$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $38295578cde97de1$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $cig2T.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $cig2T.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $3BqCE.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $cig2T.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $cig2T.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};

});
parcelRegister("4OESw", function(module, exports) {

$parcel$export(module.exports, "invariant", () => $381b8a81a7a47721$export$f5708dca728d7177);
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $381b8a81a7a47721$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $381b8a81a7a47721$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function $381b8a81a7a47721$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $381b8a81a7a47721$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $381b8a81a7a47721$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $381b8a81a7a47721$export$3fae2929ed23c202(map, pl, field) {
    return $381b8a81a7a47721$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $381b8a81a7a47721$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $381b8a81a7a47721$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === "literal";
}
function $381b8a81a7a47721$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $381b8a81a7a47721$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $381b8a81a7a47721$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});


parcelRegister("3Vy2X", function(module, exports) {

$parcel$export(module.exports, "formatList", () => $2dc11aedce2a9cdb$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $2dc11aedce2a9cdb$export$6f284aad1934db69);

var $3BqCE = parcelRequire("3BqCE");

var $9u67C = parcelRequire("9u67C");

var $1iLes = parcelRequire("1iLes");

var $cig2T = parcelRequire("cig2T");
var $2dc11aedce2a9cdb$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
var $2dc11aedce2a9cdb$var$now = Date.now();
function $2dc11aedce2a9cdb$var$generateToken(i) {
    return "".concat($2dc11aedce2a9cdb$var$now, "_").concat(i, "_").concat($2dc11aedce2a9cdb$var$now);
}
function $2dc11aedce2a9cdb$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $2dc11aedce2a9cdb$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function $2dc11aedce2a9cdb$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $1iLes.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $1iLes.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $9u67C.filterProps)(options, $2dc11aedce2a9cdb$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $2dc11aedce2a9cdb$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $3BqCE.__assign)((0, $3BqCE.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $cig2T.IntlFormatError)("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("ijUuE", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", () => $d565d2c1dbd02ef7$export$62fe1a4d9e891fa2);

var $9u67C = parcelRequire("9u67C");

var $1iLes = parcelRequire("1iLes");

var $cig2T = parcelRequire("cig2T");
var $d565d2c1dbd02ef7$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $d565d2c1dbd02ef7$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $1iLes.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $1iLes.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $9u67C.filterProps)(options, $d565d2c1dbd02ef7$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $cig2T.IntlFormatError)("Error formatting display name.", locale, e));
    }
}

});


parcelRegister("gngI6", function(module, exports) {
"use strict";

var $8CW0J = parcelRequire("8CW0J");

var $2Qk7m = parcelRequire("2Qk7m");

var $7EKCx = parcelRequire("7EKCx");
var $bebbc1a0a7776ac1$var$useSyncExternalStoreWithSelector = $7EKCx.useSyncExternalStoreWithSelector;
function $bebbc1a0a7776ac1$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = api.getState;
    var slice = $bebbc1a0a7776ac1$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
    $2Qk7m.useDebugValue(slice);
    return slice;
}
var $bebbc1a0a7776ac1$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $8CW0J.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $bebbc1a0a7776ac1$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $bebbc1a0a7776ac1$var$create = function create(createState) {
    return createState ? $bebbc1a0a7776ac1$var$createImpl(createState) : $bebbc1a0a7776ac1$var$createImpl;
};
var $bebbc1a0a7776ac1$var$react = function(createState) {
    return $bebbc1a0a7776ac1$var$create(createState);
};
module.exports.create = $bebbc1a0a7776ac1$var$create;
module.exports.default = $bebbc1a0a7776ac1$var$react;
module.exports.useStore = $bebbc1a0a7776ac1$var$useStore;
Object.keys($8CW0J).forEach(function(k) {
    if (k !== "default" && !module.exports.hasOwnProperty(k)) Object.defineProperty(module.exports, k, {
        enumerable: true,
        get: function() {
            return $8CW0J[k];
        }
    });
});
module.exports = $bebbc1a0a7776ac1$var$react;
module.exports.create = $bebbc1a0a7776ac1$var$create;
module.exports.useStore = $bebbc1a0a7776ac1$var$useStore;
module.exports.createStore = $8CW0J.createStore;
module.exports.default = module.exports;

});
parcelRegister("8CW0J", function(module, exports) {
"use strict";
var $647edf14af8579e9$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
var $647edf14af8579e9$var$createStore = function createStore(createState) {
    return createState ? $647edf14af8579e9$var$createStoreImpl(createState) : $647edf14af8579e9$var$createStoreImpl;
};
var $647edf14af8579e9$var$vanilla = function(createState) {
    return $647edf14af8579e9$var$createStore(createState);
};
module.exports.createStore = $647edf14af8579e9$var$createStore;
module.exports.default = $647edf14af8579e9$var$vanilla;
module.exports = $647edf14af8579e9$var$vanilla;
module.exports.createStore = $647edf14af8579e9$var$createStore;
module.exports.default = module.exports;

});

parcelRegister("2Qk7m", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9xGXE"));

});
parcelRegister("9xGXE", function(module, exports) {

$parcel$export(module.exports, "Children", () => $6f28854b9c781487$export$dca3b0875bd9a954, (v) => $6f28854b9c781487$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $6f28854b9c781487$export$16fa2f45be04daa8, (v) => $6f28854b9c781487$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $6f28854b9c781487$export$ffb0004e005737fa, (v) => $6f28854b9c781487$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $6f28854b9c781487$export$e2c29f18771995cb, (v) => $6f28854b9c781487$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $6f28854b9c781487$export$221d75b3f55bb0bd, (v) => $6f28854b9c781487$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $6f28854b9c781487$export$5f8d39834fd61797, (v) => $6f28854b9c781487$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6f28854b9c781487$export$74bf444e3cd11ea5, (v) => $6f28854b9c781487$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $6f28854b9c781487$export$ae55be85d98224ed, (v) => $6f28854b9c781487$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $6f28854b9c781487$export$e530037191fcd5d7, (v) => $6f28854b9c781487$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $6f28854b9c781487$export$fd42f52fd3ae1109, (v) => $6f28854b9c781487$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $6f28854b9c781487$export$c8a8987d4410bf2d, (v) => $6f28854b9c781487$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $6f28854b9c781487$export$d38cd72104c1f0e9, (v) => $6f28854b9c781487$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $6f28854b9c781487$export$7d1e3a5e95ceca43, (v) => $6f28854b9c781487$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $6f28854b9c781487$export$257a8862b851cb5b, (v) => $6f28854b9c781487$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $6f28854b9c781487$export$a8257692ac88316c, (v) => $6f28854b9c781487$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $6f28854b9c781487$export$488013bae63b21da, (v) => $6f28854b9c781487$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $6f28854b9c781487$export$7c73462e0d25e514, (v) => $6f28854b9c781487$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $6f28854b9c781487$export$7568632d0d33d16d, (v) => $6f28854b9c781487$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $6f28854b9c781487$export$88948ce120ea2619, (v) => $6f28854b9c781487$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $6f28854b9c781487$export$35808ee640e87ca7, (v) => $6f28854b9c781487$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $6f28854b9c781487$export$fae74005e78b1a27, (v) => $6f28854b9c781487$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $6f28854b9c781487$export$dc8fbce3eb94dc1e, (v) => $6f28854b9c781487$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $6f28854b9c781487$export$6a7bc4e911dc01cf, (v) => $6f28854b9c781487$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $6f28854b9c781487$export$6d9c69b0de29b591, (v) => $6f28854b9c781487$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $6f28854b9c781487$export$f680877a34711e37, (v) => $6f28854b9c781487$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $6f28854b9c781487$export$d5a552a76deda3c2, (v) => $6f28854b9c781487$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $6f28854b9c781487$export$aaabe4eda9ed9969, (v) => $6f28854b9c781487$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $6f28854b9c781487$export$e5c5a5f917a5871c, (v) => $6f28854b9c781487$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $6f28854b9c781487$export$1538c33de8887b59, (v) => $6f28854b9c781487$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $6f28854b9c781487$export$13e3392192263954, (v) => $6f28854b9c781487$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $6f28854b9c781487$export$b8f5890fc79d6aca, (v) => $6f28854b9c781487$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $6f28854b9c781487$export$60241385465d0a34, (v) => $6f28854b9c781487$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $6f28854b9c781487$export$306c0aa65ff9ec16, (v) => $6f28854b9c781487$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $6f28854b9c781487$export$7b286972b8d8ccbf, (v) => $6f28854b9c781487$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $6f28854b9c781487$export$83d89fbfd8236492, (v) => $6f28854b9c781487$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6f28854b9c781487$export$dca3b0875bd9a954;
var $6f28854b9c781487$export$16fa2f45be04daa8;
var $6f28854b9c781487$export$ffb0004e005737fa;
var $6f28854b9c781487$export$e2c29f18771995cb;
var $6f28854b9c781487$export$221d75b3f55bb0bd;
var $6f28854b9c781487$export$5f8d39834fd61797;
var $6f28854b9c781487$export$74bf444e3cd11ea5;
var $6f28854b9c781487$export$ae55be85d98224ed;
var $6f28854b9c781487$export$e530037191fcd5d7;
var $6f28854b9c781487$export$fd42f52fd3ae1109;
var $6f28854b9c781487$export$c8a8987d4410bf2d;
var $6f28854b9c781487$export$d38cd72104c1f0e9;
var $6f28854b9c781487$export$7d1e3a5e95ceca43;
var $6f28854b9c781487$export$257a8862b851cb5b;
var $6f28854b9c781487$export$a8257692ac88316c;
var $6f28854b9c781487$export$488013bae63b21da;
var $6f28854b9c781487$export$7c73462e0d25e514;
var $6f28854b9c781487$export$7568632d0d33d16d;
var $6f28854b9c781487$export$88948ce120ea2619;
var $6f28854b9c781487$export$35808ee640e87ca7;
var $6f28854b9c781487$export$fae74005e78b1a27;
var $6f28854b9c781487$export$dc8fbce3eb94dc1e;
var $6f28854b9c781487$export$6a7bc4e911dc01cf;
var $6f28854b9c781487$export$6d9c69b0de29b591;
var $6f28854b9c781487$export$f680877a34711e37;
var $6f28854b9c781487$export$d5a552a76deda3c2;
var $6f28854b9c781487$export$aaabe4eda9ed9969;
var $6f28854b9c781487$export$e5c5a5f917a5871c;
var $6f28854b9c781487$export$1538c33de8887b59;
var $6f28854b9c781487$export$13e3392192263954;
var $6f28854b9c781487$export$b8f5890fc79d6aca;
var $6f28854b9c781487$export$60241385465d0a34;
var $6f28854b9c781487$export$306c0aa65ff9ec16;
var $6f28854b9c781487$export$7b286972b8d8ccbf;
var $6f28854b9c781487$export$83d89fbfd8236492;
"use strict";
var $6f28854b9c781487$var$l = Symbol.for("react.element"), $6f28854b9c781487$var$n = Symbol.for("react.portal"), $6f28854b9c781487$var$p = Symbol.for("react.fragment"), $6f28854b9c781487$var$q = Symbol.for("react.strict_mode"), $6f28854b9c781487$var$r = Symbol.for("react.profiler"), $6f28854b9c781487$var$t = Symbol.for("react.provider"), $6f28854b9c781487$var$u = Symbol.for("react.context"), $6f28854b9c781487$var$v = Symbol.for("react.forward_ref"), $6f28854b9c781487$var$w = Symbol.for("react.suspense"), $6f28854b9c781487$var$x = Symbol.for("react.memo"), $6f28854b9c781487$var$y = Symbol.for("react.lazy"), $6f28854b9c781487$var$z = Symbol.iterator;
function $6f28854b9c781487$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $6f28854b9c781487$var$z && a[$6f28854b9c781487$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $6f28854b9c781487$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $6f28854b9c781487$var$C = Object.assign, $6f28854b9c781487$var$D = {};
function $6f28854b9c781487$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $6f28854b9c781487$var$D;
    this.updater = e || $6f28854b9c781487$var$B;
}
$6f28854b9c781487$var$E.prototype.isReactComponent = {};
$6f28854b9c781487$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$6f28854b9c781487$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $6f28854b9c781487$var$F() {}
$6f28854b9c781487$var$F.prototype = $6f28854b9c781487$var$E.prototype;
function $6f28854b9c781487$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $6f28854b9c781487$var$D;
    this.updater = e || $6f28854b9c781487$var$B;
}
var $6f28854b9c781487$var$H = $6f28854b9c781487$var$G.prototype = new $6f28854b9c781487$var$F;
$6f28854b9c781487$var$H.constructor = $6f28854b9c781487$var$G;
$6f28854b9c781487$var$C($6f28854b9c781487$var$H, $6f28854b9c781487$var$E.prototype);
$6f28854b9c781487$var$H.isPureReactComponent = !0;
var $6f28854b9c781487$var$I = Array.isArray, $6f28854b9c781487$var$J = Object.prototype.hasOwnProperty, $6f28854b9c781487$var$K = {
    current: null
}, $6f28854b9c781487$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $6f28854b9c781487$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$6f28854b9c781487$var$J.call(b, d) && !$6f28854b9c781487$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $6f28854b9c781487$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $6f28854b9c781487$var$K.current
    };
}
function $6f28854b9c781487$var$N(a, b) {
    return {
        $$typeof: $6f28854b9c781487$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $6f28854b9c781487$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6f28854b9c781487$var$l;
}
function $6f28854b9c781487$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $6f28854b9c781487$var$P = /\/+/g;
function $6f28854b9c781487$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $6f28854b9c781487$var$escape("" + a.key) : b.toString(36);
}
function $6f28854b9c781487$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $6f28854b9c781487$var$l:
                case $6f28854b9c781487$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $6f28854b9c781487$var$Q(h, 0) : d, $6f28854b9c781487$var$I(c) ? (e = "", null != a && (e = a.replace($6f28854b9c781487$var$P, "$&/") + "/"), $6f28854b9c781487$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($6f28854b9c781487$var$O(c) && (c = $6f28854b9c781487$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($6f28854b9c781487$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($6f28854b9c781487$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $6f28854b9c781487$var$Q(k, g);
        h += $6f28854b9c781487$var$R(k, b, e, f, c);
    }
    else if (f = $6f28854b9c781487$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $6f28854b9c781487$var$Q(k, g++), h += $6f28854b9c781487$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $6f28854b9c781487$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $6f28854b9c781487$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $6f28854b9c781487$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $6f28854b9c781487$var$U = {
    current: null
}, $6f28854b9c781487$var$V = {
    transition: null
}, $6f28854b9c781487$var$W = {
    ReactCurrentDispatcher: $6f28854b9c781487$var$U,
    ReactCurrentBatchConfig: $6f28854b9c781487$var$V,
    ReactCurrentOwner: $6f28854b9c781487$var$K
};
$6f28854b9c781487$export$dca3b0875bd9a954 = {
    map: $6f28854b9c781487$var$S,
    forEach: function(a, b, e) {
        $6f28854b9c781487$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $6f28854b9c781487$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $6f28854b9c781487$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$6f28854b9c781487$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$6f28854b9c781487$export$16fa2f45be04daa8 = $6f28854b9c781487$var$E;
$6f28854b9c781487$export$ffb0004e005737fa = $6f28854b9c781487$var$p;
$6f28854b9c781487$export$e2c29f18771995cb = $6f28854b9c781487$var$r;
$6f28854b9c781487$export$221d75b3f55bb0bd = $6f28854b9c781487$var$G;
$6f28854b9c781487$export$5f8d39834fd61797 = $6f28854b9c781487$var$q;
$6f28854b9c781487$export$74bf444e3cd11ea5 = $6f28854b9c781487$var$w;
$6f28854b9c781487$export$ae55be85d98224ed = $6f28854b9c781487$var$W;
$6f28854b9c781487$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $6f28854b9c781487$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $6f28854b9c781487$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$6f28854b9c781487$var$J.call(b, f) && !$6f28854b9c781487$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $6f28854b9c781487$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$6f28854b9c781487$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $6f28854b9c781487$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $6f28854b9c781487$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$6f28854b9c781487$export$c8a8987d4410bf2d = $6f28854b9c781487$var$M;
$6f28854b9c781487$export$d38cd72104c1f0e9 = function(a) {
    var b = $6f28854b9c781487$var$M.bind(null, a);
    b.type = a;
    return b;
};
$6f28854b9c781487$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$6f28854b9c781487$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $6f28854b9c781487$var$v,
        render: a
    };
};
$6f28854b9c781487$export$a8257692ac88316c = $6f28854b9c781487$var$O;
$6f28854b9c781487$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $6f28854b9c781487$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $6f28854b9c781487$var$T
    };
};
$6f28854b9c781487$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $6f28854b9c781487$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$6f28854b9c781487$export$7568632d0d33d16d = function(a) {
    var b = $6f28854b9c781487$var$V.transition;
    $6f28854b9c781487$var$V.transition = {};
    try {
        a();
    } finally{
        $6f28854b9c781487$var$V.transition = b;
    }
};
$6f28854b9c781487$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$6f28854b9c781487$export$35808ee640e87ca7 = function(a, b) {
    return $6f28854b9c781487$var$U.current.useCallback(a, b);
};
$6f28854b9c781487$export$fae74005e78b1a27 = function(a) {
    return $6f28854b9c781487$var$U.current.useContext(a);
};
$6f28854b9c781487$export$dc8fbce3eb94dc1e = function() {};
$6f28854b9c781487$export$6a7bc4e911dc01cf = function(a) {
    return $6f28854b9c781487$var$U.current.useDeferredValue(a);
};
$6f28854b9c781487$export$6d9c69b0de29b591 = function(a, b) {
    return $6f28854b9c781487$var$U.current.useEffect(a, b);
};
$6f28854b9c781487$export$f680877a34711e37 = function() {
    return $6f28854b9c781487$var$U.current.useId();
};
$6f28854b9c781487$export$d5a552a76deda3c2 = function(a, b, e) {
    return $6f28854b9c781487$var$U.current.useImperativeHandle(a, b, e);
};
$6f28854b9c781487$export$aaabe4eda9ed9969 = function(a, b) {
    return $6f28854b9c781487$var$U.current.useInsertionEffect(a, b);
};
$6f28854b9c781487$export$e5c5a5f917a5871c = function(a, b) {
    return $6f28854b9c781487$var$U.current.useLayoutEffect(a, b);
};
$6f28854b9c781487$export$1538c33de8887b59 = function(a, b) {
    return $6f28854b9c781487$var$U.current.useMemo(a, b);
};
$6f28854b9c781487$export$13e3392192263954 = function(a, b, e) {
    return $6f28854b9c781487$var$U.current.useReducer(a, b, e);
};
$6f28854b9c781487$export$b8f5890fc79d6aca = function(a) {
    return $6f28854b9c781487$var$U.current.useRef(a);
};
$6f28854b9c781487$export$60241385465d0a34 = function(a) {
    return $6f28854b9c781487$var$U.current.useState(a);
};
$6f28854b9c781487$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $6f28854b9c781487$var$U.current.useSyncExternalStore(a, b, e);
};
$6f28854b9c781487$export$7b286972b8d8ccbf = function() {
    return $6f28854b9c781487$var$U.current.useTransition();
};
$6f28854b9c781487$export$83d89fbfd8236492 = "18.2.0";

});


parcelRegister("7EKCx", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cv82G"));

});
parcelRegister("cv82G", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $919e9e5108c4b7fd$export$bf730a2d8bf68b42, (v) => $919e9e5108c4b7fd$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $919e9e5108c4b7fd$export$bf730a2d8bf68b42;
"use strict";

var $2Qk7m = parcelRequire("2Qk7m");

var $fPau3 = parcelRequire("fPau3");
function $919e9e5108c4b7fd$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $919e9e5108c4b7fd$var$q = "function" === typeof Object.is ? Object.is : $919e9e5108c4b7fd$var$p, $919e9e5108c4b7fd$var$r = $fPau3.useSyncExternalStore, $919e9e5108c4b7fd$var$t = $2Qk7m.useRef, $919e9e5108c4b7fd$var$u = $2Qk7m.useEffect, $919e9e5108c4b7fd$var$v = $2Qk7m.useMemo, $919e9e5108c4b7fd$var$w = $2Qk7m.useDebugValue;
$919e9e5108c4b7fd$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $919e9e5108c4b7fd$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $919e9e5108c4b7fd$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($919e9e5108c4b7fd$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $919e9e5108c4b7fd$var$r(a, c[0], c[1]);
    $919e9e5108c4b7fd$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $919e9e5108c4b7fd$var$w(d);
    return d;
};

});
parcelRegister("fPau3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3wHj6"));

});
parcelRegister("3wHj6", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $2915f421572439e1$export$306c0aa65ff9ec16, (v) => $2915f421572439e1$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2915f421572439e1$export$306c0aa65ff9ec16;
"use strict";

var $2Qk7m = parcelRequire("2Qk7m");
function $2915f421572439e1$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2915f421572439e1$var$k = "function" === typeof Object.is ? Object.is : $2915f421572439e1$var$h, $2915f421572439e1$var$l = $2Qk7m.useState, $2915f421572439e1$var$m = $2Qk7m.useEffect, $2915f421572439e1$var$n = $2Qk7m.useLayoutEffect, $2915f421572439e1$var$p = $2Qk7m.useDebugValue;
function $2915f421572439e1$var$q(a, b) {
    var d = b(), f = $2915f421572439e1$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2915f421572439e1$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2915f421572439e1$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2915f421572439e1$var$m(function() {
        $2915f421572439e1$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2915f421572439e1$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2915f421572439e1$var$p(d);
    return d;
}
function $2915f421572439e1$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2915f421572439e1$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2915f421572439e1$var$t(a, b) {
    return b();
}
var $2915f421572439e1$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2915f421572439e1$var$t : $2915f421572439e1$var$q;
$2915f421572439e1$export$306c0aa65ff9ec16 = void 0 !== $2Qk7m.useSyncExternalStore ? $2Qk7m.useSyncExternalStore : $2915f421572439e1$var$u;

});






parcelRegister("ecqGY", function(module, exports) {

});


parcelRegister("3BQJL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7121cd1fe93b1d4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "z", () => $b7121cd1fe93b1d4$export$2e2bcd8739ae039);

var $dHnPu = parcelRequire("dHnPu");

var $35vl8 = parcelRequire("35vl8");

var $2tVap = parcelRequire("2tVap");
var $b7121cd1fe93b1d4$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($b7121cd1fe93b1d4$export$7debb50ef11d5e0b || ($b7121cd1fe93b1d4$export$7debb50ef11d5e0b = {}));
var $b7121cd1fe93b1d4$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return (0, $35vl8._)({}, first, second);
    };
})($b7121cd1fe93b1d4$export$4aa2142c225fd5c7 || ($b7121cd1fe93b1d4$export$4aa2142c225fd5c7 = {}));
const $b7121cd1fe93b1d4$export$5716da67bfaa244d = $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $b7121cd1fe93b1d4$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $b7121cd1fe93b1d4$export$5716da67bfaa244d.undefined;
        case "string":
            return $b7121cd1fe93b1d4$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $b7121cd1fe93b1d4$export$5716da67bfaa244d.nan : $b7121cd1fe93b1d4$export$5716da67bfaa244d.number;
        case "boolean":
            return $b7121cd1fe93b1d4$export$5716da67bfaa244d.boolean;
        case "function":
            return $b7121cd1fe93b1d4$export$5716da67bfaa244d.function;
        case "bigint":
            return $b7121cd1fe93b1d4$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $b7121cd1fe93b1d4$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $b7121cd1fe93b1d4$export$5716da67bfaa244d.array;
            if (data === null) return $b7121cd1fe93b1d4$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $b7121cd1fe93b1d4$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $b7121cd1fe93b1d4$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $b7121cd1fe93b1d4$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $b7121cd1fe93b1d4$export$5716da67bfaa244d.date;
            return $b7121cd1fe93b1d4$export$5716da67bfaa244d.object;
        default:
            return $b7121cd1fe93b1d4$export$5716da67bfaa244d.unknown;
    }
};
const $b7121cd1fe93b1d4$export$5ba560653e4a1035 = $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $b7121cd1fe93b1d4$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $b7121cd1fe93b1d4$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
}
$b7121cd1fe93b1d4$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $b7121cd1fe93b1d4$export$f98dac4b251ab333(issues);
    return error;
};
const $b7121cd1fe93b1d4$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $b7121cd1fe93b1d4$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$b7121cd1fe93b1d4$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$b7121cd1fe93b1d4$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$b7121cd1fe93b1d4$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $b7121cd1fe93b1d4$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $b7121cd1fe93b1d4$var$overrideErrorMap = $b7121cd1fe93b1d4$export$341b0b6e0a6f5099;
function $b7121cd1fe93b1d4$export$1097a8289cfd22d7(map) {
    $b7121cd1fe93b1d4$var$overrideErrorMap = map;
}
function $b7121cd1fe93b1d4$export$32f27c719778d4c4() {
    return $b7121cd1fe93b1d4$var$overrideErrorMap;
}
const $b7121cd1fe93b1d4$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = (0, $2tVap._)((0, $35vl8._)({}, issueData), {
        path: fullPath
    });
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return (0, $2tVap._)((0, $35vl8._)({}, issueData), {
        path: fullPath,
        message: issueData.message || errorMessage
    });
};
const $b7121cd1fe93b1d4$export$1526d2e05f74572 = [];
function $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $b7121cd1fe93b1d4$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $b7121cd1fe93b1d4$export$32f27c719778d4c4(),
            $b7121cd1fe93b1d4$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f {
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static mergeObjectAsync(status, pairs) {
        return (0, $dHnPu._)(function*() {
            const syncPairs = [];
            for (const pair of pairs)syncPairs.push({
                key: yield pair.key,
                value: yield pair.value
            });
            return $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        })();
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (typeof value.value !== "undefined" || pair.alwaysSet) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
    constructor(){
        this.value = "valid";
    }
}
const $b7121cd1fe93b1d4$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $b7121cd1fe93b1d4$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $b7121cd1fe93b1d4$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $b7121cd1fe93b1d4$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $b7121cd1fe93b1d4$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $b7121cd1fe93b1d4$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $b7121cd1fe93b1d4$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $b7121cd1fe93b1d4$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($b7121cd1fe93b1d4$var$errorUtil || ($b7121cd1fe93b1d4$var$errorUtil = {}));
class $b7121cd1fe93b1d4$var$ParseInputLazyPath {
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
}
const $b7121cd1fe93b1d4$var$handleResult = (ctx, result)=>{
    if ($b7121cd1fe93b1d4$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $b7121cd1fe93b1d4$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $b7121cd1fe93b1d4$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $b7121cd1fe93b1d4$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $b7121cd1fe93b1d4$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $b7121cd1fe93b1d4$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($b7121cd1fe93b1d4$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $b7121cd1fe93b1d4$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $b7121cd1fe93b1d4$var$handleResult(ctx, result);
    }
    parseAsync(data, params) {
        var _this = this;
        return (0, $dHnPu._)(function*() {
            const result = yield _this.safeParseAsync(data, params);
            if (result.success) return result.data;
            throw result.error;
        })();
    }
    safeParseAsync(data, params) {
        var _this = this;
        return (0, $dHnPu._)(function*() {
            const ctx = {
                common: {
                    issues: [],
                    contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                    async: true
                },
                path: (params === null || params === void 0 ? void 0 : params.path) || [],
                schemaErrorMap: _this._def.errorMap,
                parent: null,
                data: data,
                parsedType: $b7121cd1fe93b1d4$export$3e9057828ebd5c7a(data)
            };
            const maybeAsyncResult = _this._parse({
                data: data,
                path: ctx.path,
                parent: ctx
            });
            const result = yield $b7121cd1fe93b1d4$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult);
            return $b7121cd1fe93b1d4$var$handleResult(ctx, result);
        })();
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue((0, $35vl8._)({
                    code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.custom
                }, getIssueProperties(val)));
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $b7121cd1fe93b1d4$export$a60af00cc0ce2582({
            schema: this,
            typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $b7121cd1fe93b1d4$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $b7121cd1fe93b1d4$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $b7121cd1fe93b1d4$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $b7121cd1fe93b1d4$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $b7121cd1fe93b1d4$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $b7121cd1fe93b1d4$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $b7121cd1fe93b1d4$export$a60af00cc0ce2582((0, $2tVap._)((0, $35vl8._)({}, $b7121cd1fe93b1d4$var$processCreateParams(this._def)), {
            schema: this,
            typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        }));
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $b7121cd1fe93b1d4$export$bb19b37874861e7e((0, $2tVap._)((0, $35vl8._)({}, $b7121cd1fe93b1d4$var$processCreateParams(this._def)), {
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodDefault
        }));
    }
    brand() {
        return new $b7121cd1fe93b1d4$export$66b0c798a395271f((0, $35vl8._)({
            typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodBranded,
            type: this
        }, $b7121cd1fe93b1d4$var$processCreateParams(this._def)));
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $b7121cd1fe93b1d4$export$75a44ec6249ac76b((0, $2tVap._)((0, $35vl8._)({}, $b7121cd1fe93b1d4$var$processCreateParams(this._def)), {
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodCatch
        }));
    }
    describe(description) {
        const This = this.constructor;
        return new This((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            description: description
        }));
    }
    pipe(target) {
        return $b7121cd1fe93b1d4$export$a3c3ef8a0e95c6da.create(this, target);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
}
const $b7121cd1fe93b1d4$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $b7121cd1fe93b1d4$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $b7121cd1fe93b1d4$var$ulidRegex = /[0-9A-HJKMNP-TV-Z]{26}/;
const $b7121cd1fe93b1d4$var$uuidRegex = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
const $b7121cd1fe93b1d4$var$emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $b7121cd1fe93b1d4$var$emojiRegex = RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u");
const $b7121cd1fe93b1d4$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $b7121cd1fe93b1d4$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $b7121cd1fe93b1d4$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $b7121cd1fe93b1d4$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $b7121cd1fe93b1d4$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $b7121cd1fe93b1d4$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $b7121cd1fe93b1d4$export$1230eb29b8d3b502 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        const status = new $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$b7121cd1fe93b1d4$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$b7121cd1fe93b1d4$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$b7121cd1fe93b1d4$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$b7121cd1fe93b1d4$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$b7121cd1fe93b1d4$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$b7121cd1fe93b1d4$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $b7121cd1fe93b1d4$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$b7121cd1fe93b1d4$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _addCheck(check) {
        return new $b7121cd1fe93b1d4$export$1230eb29b8d3b502((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    email(message) {
        return this._addCheck((0, $35vl8._)({
            kind: "email"
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
    }
    url(message) {
        return this._addCheck((0, $35vl8._)({
            kind: "url"
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
    }
    emoji(message) {
        return this._addCheck((0, $35vl8._)({
            kind: "emoji"
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
    }
    uuid(message) {
        return this._addCheck((0, $35vl8._)({
            kind: "uuid"
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
    }
    cuid(message) {
        return this._addCheck((0, $35vl8._)({
            kind: "cuid"
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
    }
    cuid2(message) {
        return this._addCheck((0, $35vl8._)({
            kind: "cuid2"
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
    }
    ulid(message) {
        return this._addCheck((0, $35vl8._)({
            kind: "ulid"
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
    }
    ip(options) {
        return this._addCheck((0, $35vl8._)({
            kind: "ip"
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(options)));
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck((0, $35vl8._)({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    regex(regex, message) {
        return this._addCheck((0, $35vl8._)({
            kind: "regex",
            regex: regex
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
    }
    includes(value, options) {
        return this._addCheck((0, $35vl8._)({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    startsWith(value, message) {
        return this._addCheck((0, $35vl8._)({
            kind: "startsWith",
            value: value
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
    }
    endsWith(value, message) {
        return this._addCheck((0, $35vl8._)({
            kind: "endsWith",
            value: value
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
    }
    min(minLength, message) {
        return this._addCheck((0, $35vl8._)({
            kind: "min",
            value: minLength
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
    }
    max(maxLength, message) {
        return this._addCheck((0, $35vl8._)({
            kind: "max",
            value: maxLength
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
    }
    length(len, message) {
        return this._addCheck((0, $35vl8._)({
            kind: "length",
            value: len
        }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    constructor(){
        super(...arguments);
        this._regex = (regex, validation, message)=>this.refinement((data)=>regex.test(data), (0, $35vl8._)({
                validation: validation,
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_string
            }, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message)));
        /**
         * @deprecated Use z.string().min(1) instead.
         * @see {@link ZodString.min}
         */ this.nonempty = (message)=>this.min(1, $b7121cd1fe93b1d4$var$errorUtil.errToObj(message));
        this.trim = ()=>new $b7121cd1fe93b1d4$export$1230eb29b8d3b502((0, $2tVap._)((0, $35vl8._)({}, this._def), {
                checks: [
                    ...this._def.checks,
                    {
                        kind: "trim"
                    }
                ]
            }));
        this.toLowerCase = ()=>new $b7121cd1fe93b1d4$export$1230eb29b8d3b502((0, $2tVap._)((0, $35vl8._)({}, this._def), {
                checks: [
                    ...this._def.checks,
                    {
                        kind: "toLowerCase"
                    }
                ]
            }));
        this.toUpperCase = ()=>new $b7121cd1fe93b1d4$export$1230eb29b8d3b502((0, $2tVap._)((0, $35vl8._)({}, this._def), {
                checks: [
                    ...this._def.checks,
                    {
                        kind: "toUpperCase"
                    }
                ]
            }));
    }
}
$b7121cd1fe93b1d4$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $b7121cd1fe93b1d4$export$1230eb29b8d3b502((0, $35vl8._)({
        checks: [],
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $b7121cd1fe93b1d4$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $b7121cd1fe93b1d4$export$5b070a55c0c43e09 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$b7121cd1fe93b1d4$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($b7121cd1fe93b1d4$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $b7121cd1fe93b1d4$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $b7121cd1fe93b1d4$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $b7121cd1fe93b1d4$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $b7121cd1fe93b1d4$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $b7121cd1fe93b1d4$export$5b070a55c0c43e09((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
                }
            ]
        }));
    }
    _addCheck(check) {
        return new $b7121cd1fe93b1d4$export$5b070a55c0c43e09((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
}
$b7121cd1fe93b1d4$export$5b070a55c0c43e09.create = (params)=>{
    return new $b7121cd1fe93b1d4$export$5b070a55c0c43e09((0, $35vl8._)({
        checks: [],
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$67d741fd70ff98f4 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $b7121cd1fe93b1d4$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $b7121cd1fe93b1d4$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $b7121cd1fe93b1d4$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $b7121cd1fe93b1d4$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $b7121cd1fe93b1d4$export$67d741fd70ff98f4((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
                }
            ]
        }));
    }
    _addCheck(check) {
        return new $b7121cd1fe93b1d4$export$67d741fd70ff98f4((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
}
$b7121cd1fe93b1d4$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $b7121cd1fe93b1d4$export$67d741fd70ff98f4((0, $35vl8._)({
        checks: [],
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$723d146f80596191 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf(input.data);
    }
}
$b7121cd1fe93b1d4$export$723d146f80596191.create = (params)=>{
    return new $b7121cd1fe93b1d4$export$723d146f80596191((0, $35vl8._)({
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$e974be33bdc55521 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_date
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        const status = new $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $b7121cd1fe93b1d4$export$e974be33bdc55521((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$b7121cd1fe93b1d4$export$e974be33bdc55521.create = (params)=>{
    return new $b7121cd1fe93b1d4$export$e974be33bdc55521((0, $35vl8._)({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodDate
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$bcc3b40f6b638044 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf(input.data);
    }
}
$b7121cd1fe93b1d4$export$bcc3b40f6b638044.create = (params)=>{
    return new $b7121cd1fe93b1d4$export$bcc3b40f6b638044((0, $35vl8._)({
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodSymbol
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$4e780e961c30340d extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf(input.data);
    }
}
$b7121cd1fe93b1d4$export$4e780e961c30340d.create = (params)=>{
    return new $b7121cd1fe93b1d4$export$4e780e961c30340d((0, $35vl8._)({
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodUndefined
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$a96281f914484f2d extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf(input.data);
    }
}
$b7121cd1fe93b1d4$export$a96281f914484f2d.create = (params)=>{
    return new $b7121cd1fe93b1d4$export$a96281f914484f2d((0, $35vl8._)({
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodNull
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$b9d1edb536b4e4eb extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
}
$b7121cd1fe93b1d4$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $b7121cd1fe93b1d4$export$b9d1edb536b4e4eb((0, $35vl8._)({
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodAny
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$ef3b1bb1630977ae extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
}
$b7121cd1fe93b1d4$export$ef3b1bb1630977ae.create = (params)=>{
    return new $b7121cd1fe93b1d4$export$ef3b1bb1630977ae((0, $35vl8._)({
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodUnknown
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$1e576a20c3ce9fb5 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
            code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
            expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
    }
}
$b7121cd1fe93b1d4$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $b7121cd1fe93b1d4$export$1e576a20c3ce9fb5((0, $35vl8._)({
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodNever
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$7d39f5df85f21031 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf(input.data);
    }
}
$b7121cd1fe93b1d4$export$7d39f5df85f21031.create = (params)=>{
    return new $b7121cd1fe93b1d4$export$7d39f5df85f21031((0, $35vl8._)({
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodVoid
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$7acfc3e64785411 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.array) {
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_big : $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                    code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                    code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $b7121cd1fe93b1d4$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $b7121cd1fe93b1d4$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $b7121cd1fe93b1d4$export$7acfc3e64785411((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            minLength: {
                value: minLength,
                message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
            }
        }));
    }
    max(maxLength, message) {
        return new $b7121cd1fe93b1d4$export$7acfc3e64785411((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            maxLength: {
                value: maxLength,
                message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
            }
        }));
    }
    length(len, message) {
        return new $b7121cd1fe93b1d4$export$7acfc3e64785411((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            exactLength: {
                value: len,
                message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
            }
        }));
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$b7121cd1fe93b1d4$export$7acfc3e64785411.create = (schema, params)=>{
    return new $b7121cd1fe93b1d4$export$7acfc3e64785411((0, $35vl8._)({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodArray
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
function $b7121cd1fe93b1d4$var$deepPartialify(schema) {
    if (schema instanceof $b7121cd1fe93b1d4$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $b7121cd1fe93b1d4$export$aa56fec1e9d629b8.create($b7121cd1fe93b1d4$var$deepPartialify(fieldSchema));
        }
        return new $b7121cd1fe93b1d4$export$736315c5b55efbad((0, $2tVap._)((0, $35vl8._)({}, schema._def), {
            shape: ()=>newShape
        }));
    } else if (schema instanceof $b7121cd1fe93b1d4$export$7acfc3e64785411) return new $b7121cd1fe93b1d4$export$7acfc3e64785411((0, $2tVap._)((0, $35vl8._)({}, schema._def), {
        type: $b7121cd1fe93b1d4$var$deepPartialify(schema.element)
    }));
    else if (schema instanceof $b7121cd1fe93b1d4$export$aa56fec1e9d629b8) return $b7121cd1fe93b1d4$export$aa56fec1e9d629b8.create($b7121cd1fe93b1d4$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $b7121cd1fe93b1d4$export$aaac0b8b429cef5) return $b7121cd1fe93b1d4$export$aaac0b8b429cef5.create($b7121cd1fe93b1d4$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $b7121cd1fe93b1d4$export$e2a18bb771d8e6a3) return $b7121cd1fe93b1d4$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$b7121cd1fe93b1d4$var$deepPartialify(item)));
    else return schema;
}
class $b7121cd1fe93b1d4$export$736315c5b55efbad extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $b7121cd1fe93b1d4$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $b7121cd1fe93b1d4$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $b7121cd1fe93b1d4$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                        code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $b7121cd1fe93b1d4$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(/*#__PURE__*/ (0, $dHnPu._)(function*() {
            const syncPairs = [];
            for (const pair of pairs){
                const key = yield pair.key;
                syncPairs.push({
                    key: key,
                    value: yield pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        })).then((syncPairs)=>{
            return $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $b7121cd1fe93b1d4$var$errorUtil.errToObj;
        return new $b7121cd1fe93b1d4$export$736315c5b55efbad((0, $35vl8._)((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            unknownKeys: "strict"
        }), message !== undefined ? {
            errorMap: (issue, ctx)=>{
                var _a, _b, _c, _d;
                const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                if (issue.code === "unrecognized_keys") return {
                    message: (_d = $b7121cd1fe93b1d4$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                };
                return {
                    message: defaultError
                };
            }
        } : {}));
    }
    strip() {
        return new $b7121cd1fe93b1d4$export$736315c5b55efbad((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            unknownKeys: "strip"
        }));
    }
    passthrough() {
        return new $b7121cd1fe93b1d4$export$736315c5b55efbad((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            unknownKeys: "passthrough"
        }));
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $b7121cd1fe93b1d4$export$736315c5b55efbad((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            shape: ()=>(0, $35vl8._)({}, this._def.shape(), augmentation)
        }));
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $b7121cd1fe93b1d4$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>(0, $35vl8._)({}, this._def.shape(), merging._def.shape()),
            typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $b7121cd1fe93b1d4$export$736315c5b55efbad((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            catchall: index
        }));
    }
    pick(mask) {
        const shape = {};
        $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $b7121cd1fe93b1d4$export$736315c5b55efbad((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            shape: ()=>shape
        }));
    }
    omit(mask) {
        const shape = {};
        $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $b7121cd1fe93b1d4$export$736315c5b55efbad((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            shape: ()=>shape
        }));
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $b7121cd1fe93b1d4$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $b7121cd1fe93b1d4$export$736315c5b55efbad((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            shape: ()=>newShape
        }));
    }
    required(mask) {
        const newShape = {};
        $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $b7121cd1fe93b1d4$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $b7121cd1fe93b1d4$export$736315c5b55efbad((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            shape: ()=>newShape
        }));
    }
    keyof() {
        return $b7121cd1fe93b1d4$var$createZodEnum($b7121cd1fe93b1d4$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
}
$b7121cd1fe93b1d4$export$736315c5b55efbad.create = (shape, params)=>{
    return new $b7121cd1fe93b1d4$export$736315c5b55efbad((0, $35vl8._)({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $b7121cd1fe93b1d4$export$1e576a20c3ce9fb5.create(),
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodObject
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
$b7121cd1fe93b1d4$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $b7121cd1fe93b1d4$export$736315c5b55efbad((0, $35vl8._)({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $b7121cd1fe93b1d4$export$1e576a20c3ce9fb5.create(),
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodObject
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
$b7121cd1fe93b1d4$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $b7121cd1fe93b1d4$export$736315c5b55efbad((0, $35vl8._)({
        shape: shape,
        unknownKeys: "strip",
        catchall: $b7121cd1fe93b1d4$export$1e576a20c3ce9fb5.create(),
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodObject
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$a8b236cb5070a311 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $b7121cd1fe93b1d4$export$f98dac4b251ab333(result.ctx.common.issues));
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(function() {
            var _ref = (0, $dHnPu._)(function*(option) {
                const childCtx = (0, $2tVap._)((0, $35vl8._)({}, ctx), {
                    common: (0, $2tVap._)((0, $35vl8._)({}, ctx.common), {
                        issues: []
                    }),
                    parent: null
                });
                return {
                    result: yield option._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: childCtx
                    }),
                    ctx: childCtx
                };
            });
            return function(option) {
                return _ref.apply(this, arguments);
            };
        }())).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = (0, $2tVap._)((0, $35vl8._)({}, ctx), {
                    common: (0, $2tVap._)((0, $35vl8._)({}, ctx.common), {
                        issues: []
                    }),
                    parent: null
                });
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $b7121cd1fe93b1d4$export$f98dac4b251ab333(issues));
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$b7121cd1fe93b1d4$export$a8b236cb5070a311.create = (types, params)=>{
    return new $b7121cd1fe93b1d4$export$a8b236cb5070a311((0, $35vl8._)({
        options: types,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodUnion
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $b7121cd1fe93b1d4$var$getDiscriminator = (type)=>{
    if (type instanceof $b7121cd1fe93b1d4$export$378d0cfce37406e6) return $b7121cd1fe93b1d4$var$getDiscriminator(type.schema);
    else if (type instanceof $b7121cd1fe93b1d4$export$a60af00cc0ce2582) return $b7121cd1fe93b1d4$var$getDiscriminator(type.innerType());
    else if (type instanceof $b7121cd1fe93b1d4$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $b7121cd1fe93b1d4$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $b7121cd1fe93b1d4$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $b7121cd1fe93b1d4$export$bb19b37874861e7e) return $b7121cd1fe93b1d4$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $b7121cd1fe93b1d4$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $b7121cd1fe93b1d4$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $b7121cd1fe93b1d4$export$5ef2424805ac76a3 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.object) {
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $b7121cd1fe93b1d4$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $b7121cd1fe93b1d4$export$5ef2424805ac76a3((0, $35vl8._)({
            typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap
        }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
    }
}
function $b7121cd1fe93b1d4$var$mergeValues(a, b) {
    const aType = $b7121cd1fe93b1d4$export$3e9057828ebd5c7a(a);
    const bType = $b7121cd1fe93b1d4$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $b7121cd1fe93b1d4$export$5716da67bfaa244d.object && bType === $b7121cd1fe93b1d4$export$5716da67bfaa244d.object) {
        const bKeys = $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = (0, $35vl8._)({}, a, b);
        for (const key of sharedKeys){
            const sharedValue = $b7121cd1fe93b1d4$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $b7121cd1fe93b1d4$export$5716da67bfaa244d.array && bType === $b7121cd1fe93b1d4$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $b7121cd1fe93b1d4$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $b7121cd1fe93b1d4$export$5716da67bfaa244d.date && bType === $b7121cd1fe93b1d4$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $b7121cd1fe93b1d4$export$c02deaf0bb5203d4 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($b7121cd1fe93b1d4$export$afa861e3c5730743(parsedLeft) || $b7121cd1fe93b1d4$export$afa861e3c5730743(parsedRight)) return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
            const merged = $b7121cd1fe93b1d4$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                    code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
            }
            if ($b7121cd1fe93b1d4$export$910b6cdd390341b3(parsedLeft) || $b7121cd1fe93b1d4$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$b7121cd1fe93b1d4$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $b7121cd1fe93b1d4$export$c02deaf0bb5203d4((0, $35vl8._)({
        left: left,
        right: right,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodIntersection
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$e2a18bb771d8e6a3 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.array) {
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $b7121cd1fe93b1d4$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $b7121cd1fe93b1d4$export$e2a18bb771d8e6a3((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            rest: rest
        }));
    }
}
$b7121cd1fe93b1d4$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $b7121cd1fe93b1d4$export$e2a18bb771d8e6a3((0, $35vl8._)({
        items: schemas,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodTuple,
        rest: null
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$a2acc09968cb4b7f extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.object) {
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $b7121cd1fe93b1d4$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $b7121cd1fe93b1d4$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $b7121cd1fe93b1d4$export$19342e026b58ebb7) return new $b7121cd1fe93b1d4$export$a2acc09968cb4b7f((0, $35vl8._)({
            keyType: first,
            valueType: second,
            typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodRecord
        }, $b7121cd1fe93b1d4$var$processCreateParams(third)));
        return new $b7121cd1fe93b1d4$export$a2acc09968cb4b7f((0, $35vl8._)({
            keyType: $b7121cd1fe93b1d4$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodRecord
        }, $b7121cd1fe93b1d4$var$processCreateParams(second)));
    }
}
class $b7121cd1fe93b1d4$export$163b6a2b712d9542 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.map) {
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $b7121cd1fe93b1d4$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $b7121cd1fe93b1d4$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(/*#__PURE__*/ (0, $dHnPu._)(function*() {
                for (const pair of pairs){
                    const key = yield pair.key;
                    const value = yield pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            }));
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$b7121cd1fe93b1d4$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $b7121cd1fe93b1d4$export$163b6a2b712d9542((0, $35vl8._)({
        valueType: valueType,
        keyType: keyType,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodMap
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$977057706f816712 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.set) {
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                    code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                    code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $b7121cd1fe93b1d4$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $b7121cd1fe93b1d4$export$977057706f816712((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            minSize: {
                value: minSize,
                message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
            }
        }));
    }
    max(maxSize, message) {
        return new $b7121cd1fe93b1d4$export$977057706f816712((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            maxSize: {
                value: maxSize,
                message: $b7121cd1fe93b1d4$var$errorUtil.toString(message)
            }
        }));
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$b7121cd1fe93b1d4$export$977057706f816712.create = (valueType, params)=>{
    return new $b7121cd1fe93b1d4$export$977057706f816712((0, $35vl8._)({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodSet
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$d4602ba55673f53c extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.function) {
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $b7121cd1fe93b1d4$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $b7121cd1fe93b1d4$export$32f27c719778d4c4(),
                    $b7121cd1fe93b1d4$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $b7121cd1fe93b1d4$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $b7121cd1fe93b1d4$export$32f27c719778d4c4(),
                    $b7121cd1fe93b1d4$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        var _this = this;
        if (this._def.returns instanceof $b7121cd1fe93b1d4$export$3f196b0127d6e50a) return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf(/*#__PURE__*/ (0, $dHnPu._)(function*(...args) {
            const error = new $b7121cd1fe93b1d4$export$f98dac4b251ab333([]);
            const parsedArgs = yield _this._def.args.parseAsync(args, params).catch((e)=>{
                error.addIssue(makeArgsIssue(args, e));
                throw error;
            });
            const result = yield fn(...parsedArgs);
            const parsedReturns = yield _this._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                error.addIssue(makeReturnsIssue(result, e));
                throw error;
            });
            return parsedReturns;
        }));
        else return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf((...args)=>{
            const parsedArgs = this._def.args.safeParse(args, params);
            if (!parsedArgs.success) throw new $b7121cd1fe93b1d4$export$f98dac4b251ab333([
                makeArgsIssue(args, parsedArgs.error)
            ]);
            const result = fn(...parsedArgs.data);
            const parsedReturns = this._def.returns.safeParse(result, params);
            if (!parsedReturns.success) throw new $b7121cd1fe93b1d4$export$f98dac4b251ab333([
                makeReturnsIssue(result, parsedReturns.error)
            ]);
            return parsedReturns.data;
        });
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $b7121cd1fe93b1d4$export$d4602ba55673f53c((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            args: $b7121cd1fe93b1d4$export$e2a18bb771d8e6a3.create(items).rest($b7121cd1fe93b1d4$export$ef3b1bb1630977ae.create())
        }));
    }
    returns(returnType) {
        return new $b7121cd1fe93b1d4$export$d4602ba55673f53c((0, $2tVap._)((0, $35vl8._)({}, this._def), {
            returns: returnType
        }));
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $b7121cd1fe93b1d4$export$d4602ba55673f53c((0, $35vl8._)({
            args: args ? args : $b7121cd1fe93b1d4$export$e2a18bb771d8e6a3.create([]).rest($b7121cd1fe93b1d4$export$ef3b1bb1630977ae.create()),
            returns: returns || $b7121cd1fe93b1d4$export$ef3b1bb1630977ae.create(),
            typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodFunction
        }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
    }
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
}
class $b7121cd1fe93b1d4$export$378d0cfce37406e6 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$b7121cd1fe93b1d4$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $b7121cd1fe93b1d4$export$378d0cfce37406e6((0, $35vl8._)({
        getter: getter,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodLazy
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$7e44096782a165d3 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$b7121cd1fe93b1d4$export$7e44096782a165d3.create = (value, params)=>{
    return new $b7121cd1fe93b1d4$export$7e44096782a165d3((0, $35vl8._)({
        value: value,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodLiteral
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
function $b7121cd1fe93b1d4$var$createZodEnum(values, params) {
    return new $b7121cd1fe93b1d4$export$d325d1f0e1c20179((0, $35vl8._)({
        values: values,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodEnum
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
}
class $b7121cd1fe93b1d4$export$d325d1f0e1c20179 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                expected: $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $b7121cd1fe93b1d4$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $b7121cd1fe93b1d4$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$b7121cd1fe93b1d4$export$d325d1f0e1c20179.create = $b7121cd1fe93b1d4$var$createZodEnum;
class $b7121cd1fe93b1d4$export$370b2e8d6d6f5c56 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.string && ctx.parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.number) {
            const expectedValues = $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                expected: $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$b7121cd1fe93b1d4$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $b7121cd1fe93b1d4$export$370b2e8d6d6f5c56((0, $35vl8._)({
        values: values,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodNativeEnum
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$3f196b0127d6e50a extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $b7121cd1fe93b1d4$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$b7121cd1fe93b1d4$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $b7121cd1fe93b1d4$export$3f196b0127d6e50a((0, $35vl8._)({
        type: schema,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodPromise
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$a60af00cc0ce2582 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $b7121cd1fe93b1d4$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data);
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        const checkCtx = {
            addIssue: (arg)=>{
                $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$b7121cd1fe93b1d4$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$b7121cd1fe93b1d4$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $b7121cd1fe93b1d4$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$b7121cd1fe93b1d4$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $b7121cd1fe93b1d4$export$a60af00cc0ce2582((0, $35vl8._)({
        schema: schema,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodEffects,
        effect: effect
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
$b7121cd1fe93b1d4$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $b7121cd1fe93b1d4$export$a60af00cc0ce2582((0, $35vl8._)({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodEffects
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$aa56fec1e9d629b8 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $b7121cd1fe93b1d4$export$5716da67bfaa244d.undefined) return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$b7121cd1fe93b1d4$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $b7121cd1fe93b1d4$export$aa56fec1e9d629b8((0, $35vl8._)({
        innerType: type,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodOptional
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$aaac0b8b429cef5 extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $b7121cd1fe93b1d4$export$5716da67bfaa244d.null) return $b7121cd1fe93b1d4$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$b7121cd1fe93b1d4$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $b7121cd1fe93b1d4$export$aaac0b8b429cef5((0, $35vl8._)({
        innerType: type,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodNullable
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$bb19b37874861e7e extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $b7121cd1fe93b1d4$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$b7121cd1fe93b1d4$export$bb19b37874861e7e.create = (type, params)=>{
    return new $b7121cd1fe93b1d4$export$bb19b37874861e7e((0, $35vl8._)({
        innerType: type,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$75a44ec6249ac76b extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = (0, $2tVap._)((0, $35vl8._)({}, ctx), {
            common: (0, $2tVap._)((0, $35vl8._)({}, ctx.common), {
                issues: []
            })
        });
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: (0, $35vl8._)({}, newCtx)
        });
        if ($b7121cd1fe93b1d4$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $b7121cd1fe93b1d4$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $b7121cd1fe93b1d4$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$b7121cd1fe93b1d4$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $b7121cd1fe93b1d4$export$75a44ec6249ac76b((0, $35vl8._)({
        innerType: type,
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
class $b7121cd1fe93b1d4$export$26ccfa0145e8511f extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $b7121cd1fe93b1d4$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $b7121cd1fe93b1d4$export$db7caee60e5d514d(ctx, {
                code: $b7121cd1fe93b1d4$export$5ba560653e4a1035.invalid_type,
                expected: $b7121cd1fe93b1d4$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$b7121cd1fe93b1d4$export$26ccfa0145e8511f.create = (params)=>{
    return new $b7121cd1fe93b1d4$export$26ccfa0145e8511f((0, $35vl8._)({
        typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodNaN
    }, $b7121cd1fe93b1d4$var$processCreateParams(params)));
};
const $b7121cd1fe93b1d4$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $b7121cd1fe93b1d4$export$66b0c798a395271f extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $b7121cd1fe93b1d4$export$a3c3ef8a0e95c6da extends $b7121cd1fe93b1d4$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            var _this = this;
            const handleAsync = function() {
                var _ref = (0, $dHnPu._)(function*() {
                    const inResult = yield _this._def.in._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    });
                    if (inResult.status === "aborted") return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
                    if (inResult.status === "dirty") {
                        status.dirty();
                        return $b7121cd1fe93b1d4$export$325a211da9693fcf(inResult.value);
                    } else return _this._def.out._parseAsync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx
                    });
                });
                return function handleAsync() {
                    return _ref.apply(this, arguments);
                };
            }();
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $b7121cd1fe93b1d4$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $b7121cd1fe93b1d4$export$558106ce543bd011.ZodPipeline
        });
    }
}
const $b7121cd1fe93b1d4$export$4c00f665f0d4b443 = (check, params = {}, /*
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $b7121cd1fe93b1d4$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue((0, $2tVap._)((0, $35vl8._)({
                code: "custom"
            }, p2), {
                fatal: _fatal
            }));
        }
    });
    return $b7121cd1fe93b1d4$export$b9d1edb536b4e4eb.create();
};
const $b7121cd1fe93b1d4$export$1ee8ee30835eab8b = {
    object: $b7121cd1fe93b1d4$export$736315c5b55efbad.lazycreate
};
var $b7121cd1fe93b1d4$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
})($b7121cd1fe93b1d4$export$558106ce543bd011 || ($b7121cd1fe93b1d4$export$558106ce543bd011 = {}));
const $b7121cd1fe93b1d4$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$b7121cd1fe93b1d4$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $b7121cd1fe93b1d4$export$22b082955e083ec3 = $b7121cd1fe93b1d4$export$1230eb29b8d3b502.create;
const $b7121cd1fe93b1d4$export$98e628dec113755e = $b7121cd1fe93b1d4$export$5b070a55c0c43e09.create;
const $b7121cd1fe93b1d4$export$9e06de0973666692 = $b7121cd1fe93b1d4$export$26ccfa0145e8511f.create;
const $b7121cd1fe93b1d4$export$a0f65b52274bcc00 = $b7121cd1fe93b1d4$export$67d741fd70ff98f4.create;
const $b7121cd1fe93b1d4$export$4a21f16c33752377 = $b7121cd1fe93b1d4$export$723d146f80596191.create;
const $b7121cd1fe93b1d4$export$324d90190a8b822a = $b7121cd1fe93b1d4$export$e974be33bdc55521.create;
const $b7121cd1fe93b1d4$export$8f701197936bc2a6 = $b7121cd1fe93b1d4$export$bcc3b40f6b638044.create;
const $b7121cd1fe93b1d4$export$1db45310990710a5 = $b7121cd1fe93b1d4$export$4e780e961c30340d.create;
const $b7121cd1fe93b1d4$export$7b1b591b262c240 = $b7121cd1fe93b1d4$export$a96281f914484f2d.create;
const $b7121cd1fe93b1d4$export$4154a199d7d90455 = $b7121cd1fe93b1d4$export$b9d1edb536b4e4eb.create;
const $b7121cd1fe93b1d4$export$19282c40b967aec6 = $b7121cd1fe93b1d4$export$ef3b1bb1630977ae.create;
const $b7121cd1fe93b1d4$export$b3e22bcfd64c1022 = $b7121cd1fe93b1d4$export$1e576a20c3ce9fb5.create;
const $b7121cd1fe93b1d4$export$490e536ee7389aeb = $b7121cd1fe93b1d4$export$7d39f5df85f21031.create;
const $b7121cd1fe93b1d4$export$2f23118c22fb2630 = $b7121cd1fe93b1d4$export$7acfc3e64785411.create;
const $b7121cd1fe93b1d4$export$be5493f9613cbbe = $b7121cd1fe93b1d4$export$736315c5b55efbad.create;
const $b7121cd1fe93b1d4$export$8fb0df5f40d0b477 = $b7121cd1fe93b1d4$export$736315c5b55efbad.strictCreate;
const $b7121cd1fe93b1d4$export$971dd5b0dfd021b6 = $b7121cd1fe93b1d4$export$a8b236cb5070a311.create;
const $b7121cd1fe93b1d4$export$4b888e40c4ee26dd = $b7121cd1fe93b1d4$export$5ef2424805ac76a3.create;
const $b7121cd1fe93b1d4$export$bc86dfbf7795668c = $b7121cd1fe93b1d4$export$c02deaf0bb5203d4.create;
const $b7121cd1fe93b1d4$export$65e3907585753458 = $b7121cd1fe93b1d4$export$e2a18bb771d8e6a3.create;
const $b7121cd1fe93b1d4$export$e5185e241753e543 = $b7121cd1fe93b1d4$export$a2acc09968cb4b7f.create;
const $b7121cd1fe93b1d4$export$871de8747c9eaa88 = $b7121cd1fe93b1d4$export$163b6a2b712d9542.create;
const $b7121cd1fe93b1d4$export$adaa4cf7ef1b65be = $b7121cd1fe93b1d4$export$977057706f816712.create;
const $b7121cd1fe93b1d4$export$44e51c8aac7c2deb = $b7121cd1fe93b1d4$export$d4602ba55673f53c.create;
const $b7121cd1fe93b1d4$export$488013bae63b21da = $b7121cd1fe93b1d4$export$378d0cfce37406e6.create;
const $b7121cd1fe93b1d4$export$c8ec6e1ec9fefcb0 = $b7121cd1fe93b1d4$export$7e44096782a165d3.create;
const $b7121cd1fe93b1d4$export$78a99c8d44d72635 = $b7121cd1fe93b1d4$export$d325d1f0e1c20179.create;
const $b7121cd1fe93b1d4$export$6fe7eca19ebe5199 = $b7121cd1fe93b1d4$export$370b2e8d6d6f5c56.create;
const $b7121cd1fe93b1d4$export$c957ef27a0ebfd4 = $b7121cd1fe93b1d4$export$3f196b0127d6e50a.create;
const $b7121cd1fe93b1d4$export$dc573d8a6576cdb3 = $b7121cd1fe93b1d4$export$a60af00cc0ce2582.create;
const $b7121cd1fe93b1d4$export$516e28dec6a4b6d4 = $b7121cd1fe93b1d4$export$aa56fec1e9d629b8.create;
const $b7121cd1fe93b1d4$export$133fc36489ac9add = $b7121cd1fe93b1d4$export$aaac0b8b429cef5.create;
const $b7121cd1fe93b1d4$export$fc37fe19dfda43ee = $b7121cd1fe93b1d4$export$a60af00cc0ce2582.createWithPreprocess;
const $b7121cd1fe93b1d4$export$43f28b24e1eb8181 = $b7121cd1fe93b1d4$export$a3c3ef8a0e95c6da.create;
const $b7121cd1fe93b1d4$export$3b3d07727c5b702c = ()=>$b7121cd1fe93b1d4$export$22b082955e083ec3().optional();
const $b7121cd1fe93b1d4$export$eb150471a61fced6 = ()=>$b7121cd1fe93b1d4$export$98e628dec113755e().optional();
const $b7121cd1fe93b1d4$export$269251733cdcbbf1 = ()=>$b7121cd1fe93b1d4$export$4a21f16c33752377().optional();
const $b7121cd1fe93b1d4$export$8c14e57e778d3873 = {
    string: (arg)=>$b7121cd1fe93b1d4$export$1230eb29b8d3b502.create((0, $2tVap._)((0, $35vl8._)({}, arg), {
            coerce: true
        })),
    number: (arg)=>$b7121cd1fe93b1d4$export$5b070a55c0c43e09.create((0, $2tVap._)((0, $35vl8._)({}, arg), {
            coerce: true
        })),
    boolean: (arg)=>$b7121cd1fe93b1d4$export$723d146f80596191.create((0, $2tVap._)((0, $35vl8._)({}, arg), {
            coerce: true
        })),
    bigint: (arg)=>$b7121cd1fe93b1d4$export$67d741fd70ff98f4.create((0, $2tVap._)((0, $35vl8._)({}, arg), {
            coerce: true
        })),
    date: (arg)=>$b7121cd1fe93b1d4$export$e974be33bdc55521.create((0, $2tVap._)((0, $35vl8._)({}, arg), {
            coerce: true
        }))
};
const $b7121cd1fe93b1d4$export$96c94437c95d7862 = $b7121cd1fe93b1d4$export$9a105a556e65c2c0;
var $b7121cd1fe93b1d4$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $b7121cd1fe93b1d4$export$341b0b6e0a6f5099,
    setErrorMap: $b7121cd1fe93b1d4$export$1097a8289cfd22d7,
    getErrorMap: $b7121cd1fe93b1d4$export$32f27c719778d4c4,
    makeIssue: $b7121cd1fe93b1d4$export$244a85fde9c419ed,
    EMPTY_PATH: $b7121cd1fe93b1d4$export$1526d2e05f74572,
    addIssueToContext: $b7121cd1fe93b1d4$export$db7caee60e5d514d,
    ParseStatus: $b7121cd1fe93b1d4$export$5b20a5c3d05c1f6f,
    INVALID: $b7121cd1fe93b1d4$export$9a105a556e65c2c0,
    DIRTY: $b7121cd1fe93b1d4$export$325a211da9693fcf,
    OK: $b7121cd1fe93b1d4$export$c6813a8d51f77eaf,
    isAborted: $b7121cd1fe93b1d4$export$afa861e3c5730743,
    isDirty: $b7121cd1fe93b1d4$export$910b6cdd390341b3,
    isValid: $b7121cd1fe93b1d4$export$1ea939691cdc45b8,
    isAsync: $b7121cd1fe93b1d4$export$aefee5ebe1dcfd9e,
    get util () {
        return $b7121cd1fe93b1d4$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $b7121cd1fe93b1d4$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $b7121cd1fe93b1d4$export$5716da67bfaa244d,
    getParsedType: $b7121cd1fe93b1d4$export$3e9057828ebd5c7a,
    ZodType: $b7121cd1fe93b1d4$export$19342e026b58ebb7,
    ZodString: $b7121cd1fe93b1d4$export$1230eb29b8d3b502,
    ZodNumber: $b7121cd1fe93b1d4$export$5b070a55c0c43e09,
    ZodBigInt: $b7121cd1fe93b1d4$export$67d741fd70ff98f4,
    ZodBoolean: $b7121cd1fe93b1d4$export$723d146f80596191,
    ZodDate: $b7121cd1fe93b1d4$export$e974be33bdc55521,
    ZodSymbol: $b7121cd1fe93b1d4$export$bcc3b40f6b638044,
    ZodUndefined: $b7121cd1fe93b1d4$export$4e780e961c30340d,
    ZodNull: $b7121cd1fe93b1d4$export$a96281f914484f2d,
    ZodAny: $b7121cd1fe93b1d4$export$b9d1edb536b4e4eb,
    ZodUnknown: $b7121cd1fe93b1d4$export$ef3b1bb1630977ae,
    ZodNever: $b7121cd1fe93b1d4$export$1e576a20c3ce9fb5,
    ZodVoid: $b7121cd1fe93b1d4$export$7d39f5df85f21031,
    ZodArray: $b7121cd1fe93b1d4$export$7acfc3e64785411,
    ZodObject: $b7121cd1fe93b1d4$export$736315c5b55efbad,
    ZodUnion: $b7121cd1fe93b1d4$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $b7121cd1fe93b1d4$export$5ef2424805ac76a3,
    ZodIntersection: $b7121cd1fe93b1d4$export$c02deaf0bb5203d4,
    ZodTuple: $b7121cd1fe93b1d4$export$e2a18bb771d8e6a3,
    ZodRecord: $b7121cd1fe93b1d4$export$a2acc09968cb4b7f,
    ZodMap: $b7121cd1fe93b1d4$export$163b6a2b712d9542,
    ZodSet: $b7121cd1fe93b1d4$export$977057706f816712,
    ZodFunction: $b7121cd1fe93b1d4$export$d4602ba55673f53c,
    ZodLazy: $b7121cd1fe93b1d4$export$378d0cfce37406e6,
    ZodLiteral: $b7121cd1fe93b1d4$export$7e44096782a165d3,
    ZodEnum: $b7121cd1fe93b1d4$export$d325d1f0e1c20179,
    ZodNativeEnum: $b7121cd1fe93b1d4$export$370b2e8d6d6f5c56,
    ZodPromise: $b7121cd1fe93b1d4$export$3f196b0127d6e50a,
    ZodEffects: $b7121cd1fe93b1d4$export$a60af00cc0ce2582,
    ZodTransformer: $b7121cd1fe93b1d4$export$a60af00cc0ce2582,
    ZodOptional: $b7121cd1fe93b1d4$export$aa56fec1e9d629b8,
    ZodNullable: $b7121cd1fe93b1d4$export$aaac0b8b429cef5,
    ZodDefault: $b7121cd1fe93b1d4$export$bb19b37874861e7e,
    ZodCatch: $b7121cd1fe93b1d4$export$75a44ec6249ac76b,
    ZodNaN: $b7121cd1fe93b1d4$export$26ccfa0145e8511f,
    BRAND: $b7121cd1fe93b1d4$export$cf2deea74cde46b4,
    ZodBranded: $b7121cd1fe93b1d4$export$66b0c798a395271f,
    ZodPipeline: $b7121cd1fe93b1d4$export$a3c3ef8a0e95c6da,
    custom: $b7121cd1fe93b1d4$export$4c00f665f0d4b443,
    Schema: $b7121cd1fe93b1d4$export$19342e026b58ebb7,
    ZodSchema: $b7121cd1fe93b1d4$export$19342e026b58ebb7,
    late: $b7121cd1fe93b1d4$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $b7121cd1fe93b1d4$export$558106ce543bd011;
    },
    coerce: $b7121cd1fe93b1d4$export$8c14e57e778d3873,
    any: $b7121cd1fe93b1d4$export$4154a199d7d90455,
    array: $b7121cd1fe93b1d4$export$2f23118c22fb2630,
    bigint: $b7121cd1fe93b1d4$export$a0f65b52274bcc00,
    boolean: $b7121cd1fe93b1d4$export$4a21f16c33752377,
    date: $b7121cd1fe93b1d4$export$324d90190a8b822a,
    discriminatedUnion: $b7121cd1fe93b1d4$export$4b888e40c4ee26dd,
    effect: $b7121cd1fe93b1d4$export$dc573d8a6576cdb3,
    "enum": $b7121cd1fe93b1d4$export$78a99c8d44d72635,
    "function": $b7121cd1fe93b1d4$export$44e51c8aac7c2deb,
    "instanceof": $b7121cd1fe93b1d4$export$3d916e7c22dbd8b5,
    intersection: $b7121cd1fe93b1d4$export$bc86dfbf7795668c,
    lazy: $b7121cd1fe93b1d4$export$488013bae63b21da,
    literal: $b7121cd1fe93b1d4$export$c8ec6e1ec9fefcb0,
    map: $b7121cd1fe93b1d4$export$871de8747c9eaa88,
    nan: $b7121cd1fe93b1d4$export$9e06de0973666692,
    nativeEnum: $b7121cd1fe93b1d4$export$6fe7eca19ebe5199,
    never: $b7121cd1fe93b1d4$export$b3e22bcfd64c1022,
    "null": $b7121cd1fe93b1d4$export$7b1b591b262c240,
    nullable: $b7121cd1fe93b1d4$export$133fc36489ac9add,
    number: $b7121cd1fe93b1d4$export$98e628dec113755e,
    object: $b7121cd1fe93b1d4$export$be5493f9613cbbe,
    oboolean: $b7121cd1fe93b1d4$export$269251733cdcbbf1,
    onumber: $b7121cd1fe93b1d4$export$eb150471a61fced6,
    optional: $b7121cd1fe93b1d4$export$516e28dec6a4b6d4,
    ostring: $b7121cd1fe93b1d4$export$3b3d07727c5b702c,
    pipeline: $b7121cd1fe93b1d4$export$43f28b24e1eb8181,
    preprocess: $b7121cd1fe93b1d4$export$fc37fe19dfda43ee,
    promise: $b7121cd1fe93b1d4$export$c957ef27a0ebfd4,
    record: $b7121cd1fe93b1d4$export$e5185e241753e543,
    set: $b7121cd1fe93b1d4$export$adaa4cf7ef1b65be,
    strictObject: $b7121cd1fe93b1d4$export$8fb0df5f40d0b477,
    string: $b7121cd1fe93b1d4$export$22b082955e083ec3,
    symbol: $b7121cd1fe93b1d4$export$8f701197936bc2a6,
    transformer: $b7121cd1fe93b1d4$export$dc573d8a6576cdb3,
    tuple: $b7121cd1fe93b1d4$export$65e3907585753458,
    "undefined": $b7121cd1fe93b1d4$export$1db45310990710a5,
    union: $b7121cd1fe93b1d4$export$971dd5b0dfd021b6,
    unknown: $b7121cd1fe93b1d4$export$19282c40b967aec6,
    "void": $b7121cd1fe93b1d4$export$490e536ee7389aeb,
    NEVER: $b7121cd1fe93b1d4$export$96c94437c95d7862,
    ZodIssueCode: $b7121cd1fe93b1d4$export$5ba560653e4a1035,
    quotelessJson: $b7121cd1fe93b1d4$export$913eddeaf297cfea,
    ZodError: $b7121cd1fe93b1d4$export$f98dac4b251ab333
});

});
parcelRegister("2tVap", function(module, exports) {

$parcel$export(module.exports, "_", () => $1ceaa256517f87e2$export$4fa2f4023c9cbda5);
function $1ceaa256517f87e2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1ceaa256517f87e2$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1ceaa256517f87e2$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


parcelRegister("gigCS", function(module, exports) {

$parcel$export(module.exports, "getLoggers", () => $0e4a962b0d9f7187$export$bb7d72c776e28a35);

var $jirw5 = parcelRequire("jirw5");

var $lJO9z = parcelRequire("lJO9z");
function $0e4a962b0d9f7187$var$getClientId() {
    const searchParams = new URLSearchParams(window.location.search);
    const client_id = window.__sentry__ && window.__sentry__.queryState && window.__sentry__.queryState.client_id || null;
    var _ref;
    return (_ref = client_id !== null && client_id !== void 0 ? client_id : searchParams.get("client_id")) !== null && _ref !== void 0 ? _ref : "";
}
function $0e4a962b0d9f7187$export$bb7d72c776e28a35() {
    const logAnalytics = (0, $jirw5.createLogger)((0, $jirw5.envs).getAppEnv, $0e4a962b0d9f7187$var$getClientId(), (0, $lJO9z.getRelay)(), "app-analytics");
    const logError = (0, $jirw5.createLogger)((0, $jirw5.envs).getAppEnv, $0e4a962b0d9f7187$var$getClientId(), (0, $lJO9z.getRelay)(), "app-error");
    const logCritical = (0, $jirw5.createLogger)((0, $jirw5.envs).getAppEnv, $0e4a962b0d9f7187$var$getClientId(), (0, $lJO9z.getRelay)(), "app-critical");
    const logInfo = (0, $jirw5.createLogger)((0, $jirw5.envs).getAppEnv, $0e4a962b0d9f7187$var$getClientId(), (0, $lJO9z.getRelay)(), "app-info");
    return {
        logAnalytics: logAnalytics,
        logCritical: logCritical,
        logError: logError,
        logInfo: logInfo
    };
}

});



var $h8xzT = parcelRequire("h8xzT");

var $lJO9z = parcelRequire("lJO9z");
function $04033db785ecd320$var$createLink(url) {
    const link = document.createElement("link");
    link.setAttribute("rel", "preload");
    link.setAttribute("crossorigin", "");
    link.setAttribute("href", url.toString());
    link.setAttribute("as", "fetch");
    return link;
}
const $04033db785ecd320$var$socialProviderUrl = (0, $lJO9z.buildURL)((0, $h8xzT.PATHNAMES).socialProviders);
$04033db785ecd320$var$socialProviderUrl.searchParams.set("client_id", (0, $lJO9z.getClientId)());
const $04033db785ecd320$var$localeUrl = new URL(`locales/${(0, $lJO9z.getLocale)()}.json`, window.location.origin);
const $04033db785ecd320$var$headElement = document.querySelector("head");
if ($04033db785ecd320$var$headElement) {
    $04033db785ecd320$var$headElement.appendChild($04033db785ecd320$var$createLink($04033db785ecd320$var$socialProviderUrl));
    $04033db785ecd320$var$headElement.appendChild($04033db785ecd320$var$createLink($04033db785ecd320$var$localeUrl));
}

})();
//# sourceMappingURL=index.02618849.js.map
